import { market } from "../market/pt_BR";
import { invite } from '../invite/pt_BR';
import { property } from '../property/pt_BR';
import {advertise} from '../advertise/pt_BR';
import {login, download} from '../login/pt_BR';
import {mail} from '../mail/pt_BR';
import {trading} from '../trading1/pt_BR';
import { merchandiser, common, tableList, dialog, codeInfo, hyy as contractHyy, placeOrder, codelist, panKou } from "../merchandiser/pt_BR";
import { games } from '../games/pt_BR';
import { contest } from "../contest/pt_BR";
import { taskCenter } from "../task/pt_BR";
import { ieo } from "../ieo/pt_BR";
import { earn } from "../earn/pt_BR";
import { apis } from "../api/pt_BR";
import { tradingContest } from "../tradingContest/pt_BR";
import { agent } from "../agent/pt_BR";
import { live } from "../live/pt_BR";
import { hongbao } from "../hongbao/pt_BR";


const time = {
  r: "d", // dia
  s: "h", // hora
  f: "min", // minuto
  m: "s", // segundo
};

const state = {
  preheatIng: "Pré-aquecimento",
  purchaseIng: "Em andamento",
  over: "Encerrado",
  finish: "Concluído",
  noData: "Sem dados",
  process: "Em processo",
  sellout: "Esgotado",
};

const text = {
  now: "Em andamento",
  start: "Início desta rodada em",
  end: "Fim desta rodada em",
  jd: "Progresso da rodada",
  complete: "Concluído",
  limited: "Preço com desconto por tempo limitado",
  
  finish: "Concluído",
  subscribing: "Em subscrição",
  subscribeNow: "Subscrever agora",
  buyStart: "Início da subscrição em",
  buyEnd: "Fim da subscrição em",
  projectAmount: "Número de unidades do projeto",
  quota: "Cota por unidade",
  buyPrice: "Preço de subscrição",
  buyLimit: "Limite de subscrição",
  buyAmount: "Quantidade de subscrição",
  buyPos: "Posse da moeda de subscrição",
  startDate: "Data de início",
  endDate: "Data de fim",
  projectSupport: "Apoio do projeto",
  website: "Site oficial do projeto",
  projectDetail: "Detalhes do projeto",
  cycle: "Ciclo de subscrição",
  all: "Todos",
  step1: "Pré-aquecimento",
  step2: "Subscrição",
  step3: "Sorteio",
  step4: "Publicação de resultados",
  subOrder: "Ordens de subscrição",
  myOrder: "Ordens sorteadas",
  proCoin: "Moeda do projeto",
  buyCoin: "Moeda de subscrição",
  orderDate: "Data da ordem",
  issuanceQuota: "Cota de emissão",
  dealAmount: "Quantidade negociada",
  dealPrice: "Valor negociado",
  status: "Status",
  ctrl: "Controle",
  checkOrder: "Ver ordem sorteada",
  subNum: "Número de subscrição",
  myNum: "Número sorteado",
  status0: "Subscrito",
  status1: "A aguardar pagamento",
  status2: "Concluído",
  conditionTerm1: "Até * dias antes do início da subscrição,",
  conditionTerm2: "Par de negociação *",
  conditionTerm3: "Todos os pares de negociação",
  conditionTerm4: "Acumule um valor total de negociação em moedas (USDT) de * para subscrever uma unidade",
  noData: "Dados não disponíveis",
  qgsc: "Bloqueio de compra rápida",
  yhsg: "Subscrição por sorteio",
  sgsb: "Subscrição sem sucesso",
  
  supply: "Cota desta rodada",
  rate: "Taxa de câmbio",
  ceiling: "Limite de apoio",
  xmwc: "Projeto concluído",
  xmze: "Total do projeto",
  zkjj: "Preço médio com desconto",
  cyrs: "Número de participantes",
  round: "Rodada []",
  r: "pessoas",
  cgqg: "Compra rápida bem-sucedida",
  cgzl: "Apoio bem-sucedido",
  xmed: "Cota do projeto",
  kszl: "Início do apoio em",
  ksqg: "Início da compra rápida em",
  jsqg: "Fim da compra rápida em",
  jszl: "Fim do apoio em",
  hdgz: "Regras do evento",
  xmjs: "Introdução do projeto",
  tcqr: "Se sair e confirmar o pagamento, poderá perder a oportunidade de participar nesta atividade de compra rápida. Por favor, proceda com cuidado!",
  jxtc: "Continuar a sair",
  fhzf: "Voltar para o pagamento",
  qgrsd: "Muitos participantes na compra rápida atualmente. Por favor, aguarde pacientemente!",
  zltcqr: "Se sair e confirmar o pagamento, poderá perder a oportunidade de participar nesta atividade de apoio. Por favor, proceda com cuidado!",
  zlqgrsd: "Muitos participantes no apoio atualmente. Por favor, aguarde pacientemente!",
  wxts: "Dica: por favor, confirme o pagamento o mais rápido possível. Se não concluir o pagamento em [] minutos, o pagamento expirará e a janela será fechada.",
};

const seckill = {
  sgno: "Você ainda não atendeu aos critérios de subscrição",
  srjymm: "Por favor, insira a senha de transação",
  ljzf: "Pagar agora",
};


const apply = {
  condition: "Condição de subscrição",
  apply: "Inscrever-se agora",
  buyPrice: "Preço de subscrição",
  buyAmount: "Quantidade de subscrição",
  applyAmount: "Valor da subscrição",
  forget: "Esqueceu a senha de transação?",
  noAmount: "Por favor, insira a quantidade de subscrição",
  buyLimit: "Limite de subscrição",
  success: "Subscrição bem-sucedida!",
  paySummary:
  "Dica: Por favor, confirme o pagamento o mais rápido possível. Caso contrário, o pagamento será expirado e a janela será fechada em <b>3 minutos</b>.",
  appFull: "Quantidade de subscrição é muito grande",
  seckill_async_fail_13: "O intervalo entre duas subscrições deve ser de {} minutos",
};

const seckillRes = {
  seckill_async_3: "Pagamento em andamento, aguarde!",
  seckill_async_5: "Cancelamento bem-sucedido",
  seckill_async_fail_1: "Desculpe! Por favor, atualize a página e tente novamente!",
  seckill_async_fail_2: "Desculpe! Por favor, atualize a página e tente novamente!",
  seckill_async_fail_3: "Desculpe! Por favor, atualize a página e tente novamente!",
  seckill_async_fail_4: "Desculpe! Cota esgotada!",
  seckill_async_fail_5: "Desculpe! O pagamento expirou, por favor, tente novamente!",
  seckill_async_fail_6: "Senha de pagamento incorreta, por favor, insira novamente!",
  seckill_async_fail_7: "Limite de tentativas de senha de transação excedido, tente novamente mais tarde!",
  seckill_async_fail_8: "Desculpe! O pagamento expirou, por favor, tente novamente!",
  seckill_async_fail_9: "Desculpe! A cota foi esgotada, esperamos que tenha sucesso na próxima vez!",
  seckill_async_fail_10: "Muitos participantes tentando comprar no momento, por favor, tente novamente mais tarde!",
  seckill_async_fail_11: "Falha na verificação de validação de comportamento!",
};

const header = {
  zcgl: "Gerenciamento de Ativos",
  zczh: "Conta de Ativos",
  bbzh: "Conta Spot",
  fbzh: "Conta de Compra de Criptomoedas",
  bdbzh: "Conta de Empréstimo de Criptomoedas",
  wdgl: "Gerenciamento de Pedidos",
  lswt: "Pedidos Anteriores",
  qbhz: "Transferência de Carteiras",
  yhzx: "Centro do Usuário",
  wdhb: "Meus Cupons",
  openOrder: "Pedidos Ativos",
  dealStats: "Estatísticas de Negociações",
  totalAsset: "Valor Total dos Ativos",
  cz: "Conta de Contratos",
  gmcnyt: "Comprar CNYT",
  yqfy: "Indicação",
  hbthhr: "Parceiro HBT",
  tczh: "Sair da Conta",
  moreNew: "Mais Anúncios",
  gfgg: "Anúncios Oficiais",
  zxxw: "Notícias Recentes",
  ckgd: "Ver Mais",
  bbdd: "Pedidos Spot",
  bbwhydd: "Pedidos de Contratos Perpétuos de Moeda",
  etfdd: "Pedidos ETF",
  fbdd: "Pedidos de Moeda Fiat",
};

const recommend = {
  vol24h: "Volume 24H",
  jyd: "Par de Negociação",
  jydlx: "Tipo de Par de Negociação",
  zxj: "Preço Atual",
  change24: "Variação 24H",
  line24: "Tendência de Preço (3 dias)",
};
const hyy = {
  ty: "Concordo",
  bkt: "Não abrir",
  wqdkt: "Confirmo a abertura",
  kt12: "1. Antes de participar, é fundamental que você compreenda completamente o conhecimento básico de negociação de contratos de criptomoedas, os riscos associados e as regras de negócio relacionadas à negociação de derivativos.",
  kt13: "2. As informações sobre os riscos mencionados neste aviso de risco são apenas enumerativas e não abrangem todos os fatores de risco relacionados à negociação de derivativos de ativos digitais. Antes de investir em derivativos de ativos digitais, os investidores também devem se esforçar para compreender e dominar outros fatores de risco potenciais.",
  kt14: "3. Nós sinceramente esperamos e aconselhamos os investidores a decidirem se desejam participar dessa negociação de contratos com base em sua capacidade de tolerar riscos e outras circunstâncias reais, e alocar de forma adequada seus ativos digitais.",
  kt0: "Prezado usuário:",
  kt1: "Você ainda não abriu a conta de contrato e a autorização de negociação de contrato. Por favor, leia cuidadosamente o seguinte conteúdo antes de decidir abrir:",
  kt2: "1. Ao negociar no mercado de contratos, se a tendência do preço de mercado for desfavorável para você e levar ao esgotamento da margem de sua posição, a perda será liquidada de acordo com as regras do contrato perpétuo da BiKing, e os detalhes da liquidação serão divulgados.",
  kt3: "2. Você deve ler cuidadosamente e cumprir as regras de negócio do contrato perpétuo da BiKing, compreender o mecanismo e o funcionamento do contrato e entender os vários riscos do mercado.",
  kt4: "4. O contrato perpétuo da BiKing é integrado ao sistema de negociação de contratos. O lucro e a perda da posição do usuário variam de acordo com a flutuação do mercado de contratos. Quando ocorrem grandes perdas, pode haver liquidação no sistema de negociação de contratos. Portanto, os usuários devem decidir suas ações com base nas flutuações do mercado de contratos, assumindo total responsabilidade pelos lucros e perdas, e, portanto, a BiKing não assume nenhuma responsabilidade implícita ou explícita.",
  kt5: "5. Os usuários devem cumprir conscientemente as regras relevantes da plataforma e as leis e regulamentos do país ou região. Se a conta do usuário do contrato estiver bloqueada devido a operações anormais em violação das regras, o usuário não poderá realizar operações e a plataforma não poderá fechar posições para o usuário. Se isso resultar em perdas ou liquidação, a plataforma não será responsável por isso.",
  kt6: "6. A negociação de derivativos de ativos digitais pode estar sujeita a riscos regulatórios em determinadas jurisdições. Antes de negociar, você deve fazer uma avaliação criteriosa do cenário regulatório da área em que está negociando. Devido a mudanças nas leis, regulamentos e políticas de países e regiões relevantes, alterações nas regras de negociação de contratos e a adoção de medidas emergenciais, a BiKing divulgará informações antecipadamente, informando que as posições em aberto que você mantém podem não ser mais válidas, mas os saldos de margem e lucro ainda serão resgatados.",
  kt7: "7. Devido a fatores fora do controle da plataforma, como terremotos, inundações, incêndios e outros fatores de força maior, ou falhas nos sistemas de computadores e comunicações, é possível que suas ordens não possam ser executadas ou não sejam totalmente executadas. Nesse caso, as perdas resultantes serão de responsabilidade do usuário.",
  kt8: "8. A negociação de hedging é tão arriscada quanto a negociação especulativa e também enfrenta riscos causados por flutuações de preços.",
  kta9: "9. Se você não passou pela verificação de identidade ou não vinculou a autenticação do Google ou emprestou sua conta a terceiros para operar, isso pode afetar a segurança de sua margem de contrato.",
  kta10:
  "3. Em algumas condições de mercado extremas, você pode ter dificuldades ou ser incapaz de fechar suas posições em aberto. Por exemplo, quando seus lucros estão no topo da alavancagem efetiva PnL do mercado de contratos inteiro e o lado oposto não tem fundos de seguro suficientes para cobrir suas perdas de falha.",
  kt9: "Li e estou disposto a assumir o risco",
  kt10: "Abrir conta de contrato e autorização de negociação de contrato",
  zjhz: "Transferência de fundos",
  ljhz: "Transferir agora",
  qx: "Cancelar transferência",
  khz: "Transferível",
  qxz: "Selecione",
  bz: "Moeda",
  c: "De",
  zz: "Para",
  sl: "Quantidade",
  qb: "Tudo",
  ktcg: "Abertura bem-sucedida",
  ktsb: "Falha na abertura",
  hzcg: "Transferência bem-sucedida",
  hzsb: "Falha na transferência",
  wyyd: "", //Não selecionou ler o aviso
  tc: "Sair",
  warning1: "Por favor, selecione a moeda",
  warning2: "A conta de origem não pode estar vazia",
  warning3: "A conta de destino não pode estar vazia",
  warning4: "Digite um número menor ou igual à quantidade transferível",
  warning5: "Até 4 casas decimais permitidas",
  gb: "Fechar",
  openSuccess: "Você abriu a negociação de contrato",
  openSuccessTip: "Por favor, transfira os fundos para a conta de contrato",
  wsmyz: "Você ainda não completou a verificação de identidade",
  hdnm: "Após concluir a verificação de identidade e transferir um total de []USDT, você receberá []USDT em códigos mudos",
  nmjl: "Registro de códigos mudos",
  nmhzjl: "Registro de recebimento de códigos mudos",
  gxn: "Parabéns!",
  qwjy: "Ir para a negociação",
  yfrndhyzh: "Depositado na sua conta de contrato",
  nzxy: "Você só precisa transferir []USDT para a conta de contrato para receber []USDT em códigos mudos",
  nmssm: "O que são códigos mudos",
  nm: "Código mudo",
  nxhyzh: "Você transferiu para a conta de contrato",
  text1: "Após transferir um total de []USDT para a conta de contrato, você receberá",
  text2: "Você só precisa transferir []USDT para a conta de contrato",
  text3: "para receber []USDT em códigos mudos",
  text4: "Saldo",
  text5: "Após transferir um total de []USDT para a conta de contrato, você já recebeu",
  not_get_nm: "Desculpe, a promoção de códigos mudos já terminou e esta transferência não será elegível para receber códigos mudos.",
  yijie: "1ª Camada",
  erjie: "2ª Camada",
  ljjhr: "Total transferido líquido",
  khd: "Você receberá",
  hysnm: "Códigos mudos enviados no contrato",
  bbgg: "Contrato Perpétuo Alavancagem 100x",
  hdsj: "Período da Promoção:",
  hdxq: "Detalhes da Promoção",
  ljhd: "Receber Agora",
  xdxd: "Primeiro a chegar, primeiro a ser servido",
  ylnnz: "Ganhe, leve embora; Perca, é por minha conta",
};

const Verification = {
  channel: "Canal de Verificação Oficial",
  verify: "Digite as informações que deseja verificar",
  notes: "Dicas de Segurança",
  notes1: "1. Todos os e-mails, números de WeChat, números de QQ, domínios e contas de mídia relacionadas à BiKing podem ser verificados aqui.",
  notes2: "2. Contas de mídia social (como Weibo, Twitter, etc.) só podem ser verificadas pelo nome e são sensíveis a maiúsculas e minúsculas.",
  notes3: "3. Se você tiver dúvidas sobre o resultado da verificação, pode entrar em contato com o suporte ao cliente oficial por meio do site ou aplicativo para confirmar novamente.",
  error: "Falha na Verificação",
  error1: "As informações que você pesquisou",
  error2: "não foram verificadas como um canal oficial. Por favor, proteja a segurança dos seus ativos e tome cuidado com vazamento de informações pessoais.",
  errorNote: "Observações",
  errorNote1: "1. Atualmente, o canal de verificação oficial suporta apenas e-mails, números de WeChat, números de QQ, domínios e contas de mídia social.",
  errorNote2: "2. Ferramentas de chat, como WeChat, suportam apenas a pesquisa por número da conta (não o apelido).",
  errorNote3: "3. Contas de mídia social só podem ser verificadas pelo nome e são sensíveis a maiúsculas e minúsculas.",
  success: "Verificação Bem-Sucedida",
  success1: "As informações que você pesquisou:",
  success2: "foram verificadas como oficiais da BiKing",
  success3: ". Se esta conta aparecer em outros canais, não é confiável. Por favor, tome cuidado com a segurança dos seus ativos.",
  more: "Ver Mais",
  know: "Eu Entendi",
  weChat: "WeChat",
  name: "Nome de Domínio",
  webo: "Weibo",
  twitter: "Twitter",
  email: "E-mail",
  contact: "Contatar o Suporte",
  bannerTip: "Para evitar que criminosos usem o nome da BiKing para fraudes, você pode usar esta página para confirmar se o número de telefone, WeChat etc. que entram em contato com você é um canal oficial da BiKing.",
};


const index = {
  downloadIos: 'Baixar na AppStore',
  downloadAndroid: 'Baixar para Android',
  downloadGoogle: 'Baixar para Google Play'
};

const indexPage = {
  gfgg: "Notícias Oficiais",
  zxxw: "Últimas Notícias",
  ckgd: "Ver mais",
};

const NAVS = {
  xh: 'À vista',
  hhjy: 'negociação de swap',
  ty: 'esporte',
  hqsj: 'Mercado',
  game: 'Jogo',
  fx: 'Descobrir',
  sj: 'Dados',
  fb: "Comprar",
  bb: "Negociação Spot",
  jr: "Earn",
  jyds: 'Concurso Negociação',
  hbhd: "Evento do Pacote Vermelho",
  gg: "Negociação com Alavancagem",
  yxhy: "Contratos Perpétuos",
  eft: "Negociação de ETF",
  flhd: "Promoções",
  flzx: "Promoções",
  fast: "Negociação Rápida",
  spec: "Negociação Profissional",
  login: "Entrar",
  rig: "Registrar",
  downapp: "Baixar APP BiKing",
  downappsum: "Experiência Fluída, Depósitos e Saques Rápidos",
  zichan: "Ativos",
  order: "Pedidos",
  qbhz: "Transferência de Carteiras",
  lang: "Idioma",
  calc: "Caminho",
  
  mb: "Comprar",
  hq: "Mercado",
  hy: "Contratos",
  jy: "Negociação",
  lc: "Ganhar Criptomoedas",
  fs: "Fansup",
  xy: "Academia",
  byxy: "Academia BiKing",
  byyx: "Pesquisa BiKing",
  coins: "Pontos COINS",
  gd: "Mais",
  yqhy: "Convide Amigos",
  rwzx: "Centro de Tarefas",
  bbms: "Compre criptomoedas usando USDT",
  ggms: "Plataforma de empréstimos de criptomoedas, amplie lucros e riscos",
  yxms: "Alavancagem de até 100x, operações fáceis e variadas",
  etfms: "Amplie lucros, sem risco de liquidação",
  pool: "Pool Compartilhado",
  czzn: 'Guia de Operações',
  gywm: 'Sobre Nós',
  zhxx: 'Informações da Conta',
  gd:"Copiar Negociação",
  yxhy: "Contratos Perpétuos",
  zjhy: "Contratos de Bônus",
  product: "produto"
};

const FOOTERS = {
  zxkf: "Atendimento ao Cliente Online",
  fawu: "Aconselhamento Jurídico",

  us: "Sobre Nós",
  product: "Produtos",
  service: "Serviços",
  college: "Academia",

  aboutUs: "Sobre Nós",
  rateSum: "Explicação de Taxas",
  notices: "Centro de Notícias",
  helps: "Centro de Ajuda",
  verific: "Canal de Verificação Oficial",
  contact: "Contate-nos",

  fabi: "Comprar",
  bibi: "Negociação Spot",
  ganggan: "Negociação com Alavancagem",
  swiper: "Contratos Perpétuos",
  etf: "Negociação de ETF",
  licai: "Ganhar Criptomoedas",

  apis: "Suporte de API",
  apisNew: "Suporte de API",
  addCoin: "Solicitação de Listagem de Criptomoeda",
  vips: "Benefícios VIP",
  downapp: "Baixar APP",
  files: "Documentos Legais",

  newuser: "Novatos BiKing",
  swiperSchool: "Academia de Contratos",
  assistant: "Assistente de Aprendizado",
  digitalintroduction: "Introdução às Criptomoedas",

  watchword: "Plataforma de Negociação Verde de Nível Internacional",
  meiyitian: "Todos os dias, faça riquezas acontecerem",
  chat: "Chat",
  shequncn: "Comunidade do Telegram em Chinês",
  shequnen: "Comunidade do Telegram em Inglês",
  shequnkr: "Comunidade do Telegram em Coreano",
};

const SIDEBAR = {
  newuser: "Iniciante",
  guide: "Guia",
  bbsq: "Comunidade de Negociação",
  hysq: "Comunidade de Contratos",
  gd: "Fixo",
  sq: "Recolher",
};


const banner = {
  wzwh: 'Usar o site Biking e/ou manter sua conta indica sua concordância com nossos atualizados',
  sytk: 'Termos de Uso',
  yszc: 'Política de Privacidade',
  hh: 'e',
  cookie: 'Política de Cookies',
  djgb: 'Clicar em “X” indica que você reconhece ter lido e concorda com os termos e políticas acima.',
  
  title: 'Plataforma de jogos e negociação de criptomoedas diversificada',
  marketTitle: 'Negociação de criptomoedas - Somos especialistas',
  marketSubTitle: 'Comprometidos em fornecer serviços de negociação de derivativos de ativos criptográficos mais seguros e estáveis para os usuários',
  pathTitle: 'Seu assistente confiável na jornada das criptomoedas',
  pathSubTitle: 'Escolha de milhões de usuários, uma plataforma confiável em que você pode confiar',
  jylz: 'US$ 300 bilhões',
  jyl: 'Volume de negociação em 72 horas',
  sxs: 'Criptomoedas listadas',
  zcyh: 'Usuários registrados',
  zdjy: 'Menor taxa de negociação',
  connectTitle: 'Por que nos escolher',
  connectSubTitle: 'BiKing ajuda você a criar, valorizar e armazenar riqueza',
  advantageText1: 'Desempenho de ponta · Negociação ultrarrápida',
  advantageSubText1: 'Impulsionado pela tecnologia da Bolsa de Valores de Londres, baixa latência, correspondência ultrarrápida',
  advantageText2: 'Proteção de ativos · Segurança extrema',
  advantageSubText2: 'BiKing atende ao padrão CCSS, garantindo a segurança dos ativos e dos dados',
  advantageText3: 'Alta liquidez · Spread baixo',
  advantageSubText3: 'Negociação alavancada de contratos da BiKing, alta eficiência, mínimo desvio',
  advantageText4: 'Serviço 24 horas por dia',
  advantageSubText4: 'Garantir o funcionamento normal do sistema e fornecer atendimento ao cliente 24 horas por dia',
  advantageText5: 'Conveniente e fácil de usar',
  advantageSubText5: 'Oferecendo diversos sistemas de pedidos e ferramentas de negociação, com risco controlável',
  advantageText6: 'Negocie com tranquilidade a qualquer hora e em qualquer lugar',
  advantageSubText6: 'A plataforma BiKing oferece versão web, aplicativo para celular, API e conexão FIX',
  netWorkTitle: 'A escolha comum de 1,2 milhões de usuários em 26 países',
  netWorkSubTitle: 'Comprometidos em fornecer serviços de negociação de derivativos de ativos criptográficos mais seguros e estáveis para os usuários',
  smxz: 'Escanear para baixar',
  fxbzj: 'Margem de garantia',
  fkbz: 'Assegure-se de que cada transação seja abrangida por proteção financeira abrangente',
  question1: '1. Introdução à BiKing Exchange',
  questionContent1: 'A BiKing Exchange é uma plataforma global líder em negociação de ativos digitais com sede em Cingapura. Com licenças duplas MSB dos EUA / Canadá, a plataforma oferece diversos serviços, incluindo negociação, armazenamento e gerenciamento de ativos digitais.',
  question2: '2. Quais produtos a BiKing Exchange oferece?',
  questionContent2: 'A BiKing Exchange oferece os seguintes produtos: Contratos Perpétuos - profundidade superior, correspondência ultrarrápida; Negociação Spot - taxa 0, execução rápida; Comunidade de Seguimento de Ordens - traders experientes, estratégias estáveis; Negociação com Bônus - modelo exclusivo, benefícios contínuos; Web Wallet - serviços descentralizados integrados',
  question3: '3. Como se registrar na BiKing Exchange?',
  questionContent3: 'Você pode se registrar na BiKing Exchange através do site oficial ou do aplicativo BiKing. Clique em "Registrar" e siga o processo de registro para começar a investir e gerenciar ativos digitais na BiKing Exchange.',
  question4: '4. Como comprar criptomoedas na BiKing Exchange?',
  questionContent4: 'A BiKing Exchange oferece suporte para compra rápida de criptomoedas com várias opções de pagamento e várias moedas fiduciárias, fornecendo aos usuários globais mais escolhas e conveniência. Independentemente do país ou região, os usuários podem facilmente comprar criptomoedas usando sua moeda local.',
  question5: '5. Como negociar ativos digitais?',
  questionContent5: 'Você pode escolher o ativo digital que deseja negociar na BiKing Exchange. Após acessar a página de negociação, escolha comprar ou vender, insira a quantidade e o preço de negociação e confirme a negociação. A BiKing Exchange suporta diversos ativos digitais, incluindo Bitcoin, Ethereum, Litecoin, Ripple, entre outros.',
  question6: '6. Como a BiKing Exchange protege os ativos dos usuários?',
  questionContent6: 'A BiKing Exchange utiliza tecnologia de criptografia de várias camadas para proteger as informações e os ativos dos usuários. Além disso, a plataforma adota um método de armazenamento separado de carteira fria e quente para garantir a segurança dos ativos dos usuários.',
  investor: 'Confiança de 3 milhões de investidores de criptomoedas',
  transaction: 'Investindo, negociando e crescendo na BiKing',
  hypt: 'Líder mundial em plataforma de negociação de ativos digitais seguros',
  yjpc: 'Abra e feche posições com um clique',
  jscrj: 'Depósitos e retiradas ultrarrápidos, negociação em 60 segundos para alcançar negociações sem desvio',
  zcpt: 'Registrar e receba USDT',
  email: 'Endereço de e-mail',
  phone: 'Número de telefone',
  zc: 'Registrar',
  yhjaqbz: 'Proteção de segurança de nível bancário',
  lhdmch: 'Correspondência ultrarrápida sem desvio',
  qthkf: 'Atendimento ao cliente 24 horas por dia, 7 dias por semana',
  rmjmhb: 'Criptomoedas populares',
  jrsq: 'Junte-se à comunidade de ciclistas',
  hqzxhd: 'Obtenha as informações mais recentes sobre eventos de ciclismo e suporte online',
};

const navCard = {
  join: 'Junte-se ao BiKing',
  hzdl: 'BiKing Coin King - Contrato de agente de cooperação. Aguardamos a sua adesão.',
  jmrx: 'Linha direta para adesão de agentes: 183283232998',
  contract: 'Contrato online',
  yxhy: 'Negocie rapidamente com a emocionante chegada do contrato duplo BiKing币王双合约',
  jylh: 'Negociação mais flexível, lucros mais abundantes',
  usa: 'EUA E CANADÁ MSB',
  zmjys: 'A famosa exchange estrangeira BiKing币王 recebeu múltiplas licenças de conformidade',
  fxpf: 'O risco é pago, seguro e confiável',
  srhy: 'Primeira entrada no contrato BiKing, ganhe 30% de lucro real',
  hdsj: 'Período da promoção: de 01 de novembro de 2022, 0h, até 01 de dezembro de 2022, 0h'
}
const choice = {
  gjyh: '26 países, 1,2 milhão de usuários escolheram BiKing',
  jyfu: 'Comprometidos em fornecer serviços de negociação de derivativos de ativos criptográficos mais seguros e estáveis aos usuários',
  wsmxzwm: 'Por que nos escolher',
  jsty: 'Experiência em alta velocidade',
  jmsj: 'A interface de negociação foi projetada com base na experiência operacional de vários anos da plataforma, com um processo claro e operações convenientes. Além disso, ela possui tecnologia de correspondência de memória principal em microssegundos, proporcionando aos usuários uma experiência de negociação mais conveniente e confortável.',
  kfx: 'Mecanismo de Preço à Prova de Risco',
  pthybz: 'O preço da plataforma para contratos de criptomoedas usa um algoritmo de índices integrados de múltiplas fontes, com forte capacidade de controle de risco, evitando efetivamente o risco e as perdas para os usuários causados pela volatilidade do mercado em situações extremas.',
  zjaqbz: 'Garantia de Segurança de Fundos',
  zjdt: 'Todos os fundos têm assinaturas dinâmicas múltiplas offline para garantir decisões em microssegundos e são armazenados em armazenamento frio de alta profundidade, protegendo totalmente a segurança dos fundos dos usuários e fornecendo controle de risco de segurança de nível bancário para cada usuário.',
  jszc: 'Suporte de Tecnologia de Ponta',
  ptjstd: 'A equipe técnica da plataforma é composta por um grupo de especialistas em tecnologia blockchain de primeira linha, garantindo uma experiência de usuário impecável e fornecendo um forte suporte técnico para o desenvolvimento e operação da plataforma.',
  jcjz: 'Mecanismo de Liquidação Gradual',
  hqbh: 'Com base nas mudanças do mercado, o mecanismo de controle de risco dos usuários é acionado de forma razoável, fornecendo proteção abrangente aos ativos dos usuários 24 horas por dia.',
  kf: 'Atendimento ao cliente 24 horas',
  ptkf: 'A plataforma adota um sistema de atendimento ao cliente 24 horas por dia, garantindo tratamento atencioso para cada problema enfrentado pelos usuários.'
}
const plat = {
  ptgn: 'Funcionalidades da Plataforma',
  zjms: 'Modo de Bônus',
  zjjs: 'O Modo de Bônus é uma nova forma especial de contrato lançada pela equipe da BiKing para todos os usuários de contratos na plataforma. O processo de operação do Modo de Bônus é o mesmo que o contrato real. Os lucros obtidos ao abrir uma posição podem ser transferidos para a conta de contrato para continuar abrindo posições ou retirar diretamente. As formas de obtenção incluem: reembolso de taxas em tempo real, airdrops de eventos, conclusão de tarefas, entre outros.',
  zcms: 'Modo de Cobertura Total',
  zcjs: 'No Modo de Cobertura Total, todas as posições compartilham o mesmo capital de garantia e lucros e perdas flutuantes são interligados. Isso inclui o capital de garantia das posições abertas como capital flutuante em todas as contas. O Modo de Cobertura Total possui uma forte capacidade de controle de risco, mas também é suscetível a exceder as expectativas de perda em mercados altamente voláteis.',
  zucms: 'Modo de Cobertura Individual',
  zucjs: 'No Modo de Cobertura Individual, cada ordem é independente e os lucros e perdas são calculados independentemente com base no preço de abertura de cada posição. Quando o capital de uma ordem (ou seja, a margem) atinge o ponto de stop loss máximo, a posição será liquidada automaticamente. Quando os lucros atingem o ponto de take profit máximo, a posição é liquidada automaticamente. Quando existem ordens ou ordens planejadas em aberto no Modo de Cobertura Individual, não é possível alternar para o Modo de Cobertura Total para abrir posições.',
  gdgn: 'Funcionalidade de Seguir',
  gdjs: 'Após ativar a funcionalidade de seguir, todas as ações de abertura e fechamento das posições dos traders seguidos serão executadas automaticamente em sincronia. A sincronização só não será concluída em caso de saldo insuficiente na conta ou exceder o limite de posições abertas. Se a funcionalidade de seguir não for desativada manualmente, ela permanecerá ativada.',
  bfpc: 'Fechar Parcialmente',
  bfjs: 'Ao possuir uma quantidade específica de posições longas ou curtas, é possível escolher livremente o valor a ser fechado com base na variação do mercado e nos lucros e perdas. Ao mesmo tempo, o lucro ou prejuízo das posições será calculado proporcionalmente com base na relação entre o valor fechado e o total de margem. O lucro flutuante não será alterado após o fechamento parcial.',
  fxkc: 'Abrir em Sentido Contrário',
  fxjs: 'O sistema fechará automaticamente a posição atualmente selecionada ao preço de mercado mais favorável e abrirá automaticamente uma posição na direção contrária com a mesma quantidade de contratos ao preço de mercado mais favorável. Isso evita perder oportunidades em caso de inversão do mercado.',
  zjbzj: 'Adicionar Margem',
  zjbzjjs: 'Ao possuir uma quantidade específica de posições longas ou curtas, é possível adicionar margem nas condições atuais de cada posição. Após adicionar margem, o fator de posição será calculado usando fórmulas de ponderação com base nos parâmetros da posição no momento da abertura e da adição de margem.'
}

const risk = {
  fxbzj: 'Margem de Garantia de Risco',
  fxbz: 'Proporcionando proteção abrangente de risco de fundos para cada negociação'
}

const license = {
  license: 'BiKing recebeu a licença financeira MSB',
  hgyy: 'Operações em conformidade, presença global',
  login: 'Entrar',
  download: 'Baixe o BiKing digitalizando o código',
  support: 'Suporte',
  jsjy: 'Negocie a qualquer momento, rápida execução',
  ljxz: 'Baixe o App BiKing agora'
}


const footer = {
  yhyh: 'Mais amigável para o usuário',
  jypt: 'Plataforma de negociação de contratos',
  yhzc: 'Suporte ao Usuário',
  flsm: 'Explicação de Taxas',
  ggzx: 'Centro de Notícias',
  yhxz: 'Avisos ao Usuário',
  tksm: 'Termos de Uso',
  fxzs: 'Aviso de Risco',
  xylb: 'Lista de Acordos',
  gywm: 'Sobre Nós',
  gy: 'Sobre',
  lxwm: 'Contate-nos',
  appxz: 'Baixar o App',
  callus: 'Assine o Boletim Informativo da BIKING',
  zwzxxx: 'Fique por dentro das últimas notícias, insights e flutuações de preços',
  zc: 'Registrar',
  email: 'Endereço de E-mail',
  callingus: 'Contate-nos',
  bqsy: 'Todos os direitos reservados',
  tips: 'Aviso: Investir envolve riscos, entre no mercado com cautela'
}

const card = {
  title: 'Por que somos a plataforma de contratos mais amigável',
  text: 'BiKing ajuda a criar, valorizar e preservar sua riqueza',
  djxn: 'Reembolso de Taxas',
  jsqd: 'Reembolso de 100% das taxas em tempo real, reduzindo significativamente os custos de negociação e aumentando as oportunidades de lucro',
  zcbz: 'Depósitos e Saques Rápidos',
  cssbz: 'Depósitos e saques rápidos e suaves, garantindo a segurança dos fundos do usuário e não perdendo nenhuma oportunidade de negociação',
  gld: 'Conveniência e Facilidade de Uso',
  zxhd: 'Registro e abertura de posições em apenas 10 segundos, sistema exclusivo de segurança e proteção da privacidade do usuário, processo de registro mais simples',
  qthfw: 'Suporte 24/7',
  kffw: 'Experiência de interação confortável e suave, mecanismo de margem padrão ouro e atendimento ao cliente online 24 horas para respostas em tempo real a problemas de negociação',
  bjyy: 'Ferramentas de Negociação Abundantes',
  fxkk: 'Oferecemos diversos sistemas de pedidos e ferramentas de negociação para controle de riscos',
  axjy: 'Negociação Segura a Qualquer Hora e em Qualquer Lugar',
  bkms: 'A plataforma BiKing oferece versões para web, aplicativo móvel, API e conexões FIX'
}
const news = {
  title: 'Notícias & Perspectivas',
  text: 'Fique por dentro das notícias e características do mundo das principais bolsas de criptomoedas',
  sy: 'Perspectivas',
  ltitle: 'Bitcoin pode resolver desafios únicos em mercados emergentes',
  ldesc: 'Este artigo inicialmente visto em Cointelegraph. Com o foco no desenvolvimento de mercados emergentes no Blockchain Economy Lstanbul Summit, a adoção do Bitcoin continua sendo impulsionada pela demanda de casos de uso específicos?...',
  more: 'Saiba Mais',
  xwfbs1: 'Sala de Imprensa',
  rdesc1: 'A bolsa de criptomoedas BiKing patrocina o Blockchain Economy Lstanbul Summit 2022',
  xwfbs2: 'Sala de Imprensa',
  rdesc2: 'A bolsa de criptomoedas BiKing patrocina o Blockchain Economy Lstanbul Summit 2022',
}
const info = {
  hzhb: 'Parceiro de Plataforma de Negociação Automatizada',
  qsjy: 'Negocie facilmente na BiKing usando robôs de negociação',
  quadency: 'QUADENCY',
  clpt: 'Plataforma profissional de estratégias de negociação automatizada',
  stacked: 'Stacked',
  glcf: 'Os usuários podem usar o Stacked para investir em índices criptográficos, realizar negociações automatizadas e gerenciar riqueza'
}


const menu = {
  creditCardOrder: 'Ordem de pagamento',
  ptmb: 'C2C',
  kjmb: 'Compra Rápida de Criptomoedas',
  xykmb: 'Compra de Criptomoedas com Cartão de Crédito',
  order: 'Ordem',
  userOrder: 'Ordens do Usuário',
  merchantOrder: 'Ordens do Comerciante',
  quickOrder: 'Ordens Rápidas',
  merchant:'Comerciante',
  asMerchant:'Torne-se um Comerciante',
  advertisingManage: 'Gerenciar Anúncios',
  financialStatements: 'Demonstrações Financeiras',
  messageCenter: 'Centro de Mensagens',
  more: 'Mais',
  paymentSettings: 'Configurações de Pagamento',
  publish: 'Publicar Anúncio',
  overview: 'Visão Geral',
  aqzx: 'Centro de Segurança',
  phsz: 'Configurações de Preferência',
  hykhj: 'Temporada de carnaval de contratos, uma nova era de negociação',
  xszn: 'Guia para iniciantes',
  bwyjy: 'Instituto de Pesquisa Biking',
  bwsq: 'Comunidade Biking',
  yhxz: 'Informações do usuário',
  bwysp: 'Derivativos do Rei da Moeda',
  jyxz: 'Instruções de negociação OTC'
}


const otc = {
  Realtimequotes:'Báo giá theo thời gian thực chỉ mang tính chất tham khảo. Vui lòng tham khảo giá trên trang web của nhà cung cấp dịch vụ bên thứ ba để biết thêm thông tin.',
  Realtimequotes1:'Limite de Transação',
  Realtimequotes2:'Preço de Referência  （{price}）',
  Realtimequotes3:'Compra',
  Realtimequotes5:'Insira o valor da compra',
  Realtimequotes6:'Máximo',
  Realtimequotes7:'Excede o Limite Máximo',
  Realtimequotes8:'Quantidade',
  Realtimequotes9:'Taxas de Processamento',
  Realtimequotes10:'Método de Pagamento',
  Realtimequotes11:'Prazo de Entrega',
  Realtimequotes12:'10 a 20 minutos após o pagamento ser efetuado',
  Realtimequotes13:'Confirme sua compra',
  Realtimequotes14:'Etapas da Compra',
  Realtimequotes15:'Selecione a moeda digital que deseja comprar, a moeda fiduciária que deseja utilizar e o provedor de serviços que deseja utilizar.',
  Realtimequotes16:'Insira o valor da compra, preencha suas informações no site do provedor de serviços terceirizado e conclua o pagamento.',
  Realtimequotes17:'Visualize a moeda digital comprada no seu histórico de recargas de ativos BiKing e os detalhes do pedido no site do provedor de serviços.',
  Realtimequotes18:'Você será redirecionado para {XXXXX} para efetuar sua compra.',
  Realtimequotes24:'Lembrete',
  Realtimequotes19:'{XXXXX} é uma plataforma de negociação de moedas fiduciárias e criptomoedas de terceiros, operada de forma independente. Todos os serviços relacionados são fornecidos pela {XXXXX}.',
  Realtimequotes20:'O preço de referência inclui as taxas de plataforma. O preço real da transação é baseado no preço no site oficial da {XXXXX}.;',
  Realtimequotes21:'A BiKing não se responsabiliza por quaisquer perdas ou danos incorridos como resultado da utilização deste serviço.',
  Realtimequotes22:'Aparentemente, prossiga agora.',
    Realtimequotes23:'valor da compra',
  Realtimequotes25:'Transações de terceiros',
  Realtimequotes26:'Preencha seu endereço de e-mail primeiro',
    Realtimequotes27:'Preencha agora.',
     Realtimequotes28:'Nome do comerciante terceirizado',
  meBuy: 'Quero comprar',
    服务商: 'Provedor de Serviços',
  bjgq: "A cotação expirou, por favor, obtenha-a novamente.",
  gxbj: "Atualizar cotação",
  zxkdh: 'Mínimo disponível para troca {min} {symbol}',
  zdkdh: 'Máximo disponível para troca {max} {symbol}',
  Available: 'Saldo disponível',
  Unknown: 'desconhecido',
  qxgz: 'Política de cancelamento: Se o comprador acumular mais de 200 cancelamentos em um único dia, a funcionalidade de compra será restrita para esse dia.',
  xncs: 'Vender para você',
  qxzzffs: 'Por favor, selecione o método de pagamento',
  qdqx: 'Confirmar cancelamento',
  wzxx: 'Eu vou pensar de novo',
  msk: 'Método de pagamento do comprador',
  zhmc: 'Nome da conta',
  zhxq: 'Detalhes da conta',
  xzhb: 'Escolher moeda',
  
  buyer: 'Comprador',
  seller: 'Vendedor',
  goSet: 'Ir para Configurações',
  addPayWayTitle: 'Adicionar Método de Pagamento',
  addPayWay: 'Você precisa adicionar ou ativar pelo menos um método de pagamento para {type} criptomoedas.',
  supportPayWay: 'Você precisa adicionar e ativar um método de pagamento suportado para {type}.',
  top: 'Fixar no Topo',
  marginTips: 'Você já depositou {baseMarginPaid} USDT de margem. É necessário depositar no mínimo {needMargin} USDT.',
  eyqx: 'Você pode cancelar a disputa até 3 vezes por dia. Caso contrário, a opção de iniciar disputa será restrita. Se for identificado como cancelamento malicioso, sua conta será suspensa. Por favor, tenha cuidado!',
  qdbzgm: 'Tem certeza de que não deseja comprar mais?',
  qxbtk: 'Ao cancelar o pedido, não haverá reembolso. Se você já fez o pagamento, não cancele o pedido.',
  yzjbzj: 'O vendedor comum aumentou a margem',
  xbjjcbzj: 'Você precisa complementar a margem básica',
  jg: 'Preço',
  zxjgxd: 'Realizar pedido ao preço mais recente',
  je: 'Valor',

  ccxe: 'Excede o limite',
  yebz: 'Saldo insuficiente',
  qxsm: 'Por favor, faça a verificação de identidade primeiro',

  dfb: 'Aguardando liberação',
  jywc: 'Concluído',
  buy: 'Comprar',
  sell: 'Vender',
  coin: 'Moeda',
  allCoin: 'Todas as Moedas',
  frenchCurrency: 'Moeda Fiduciária',
  payWay: 'Método de Pagamento',
  all: 'Todos',
  bankCard: 'Cartão Bancário',
  zfb: 'Alipay',
  wx: 'WeChat',
  search: 'Pesquisar',
  merchant: 'Comerciante (Pedidos Concluídos em 30 Dias / Taxa de Conclusão em 30 Dias)',
  turnover: 'Volume de Negociação',
  completionRate: 'Taxa de Conclusão',
  quotaOrNumber: 'Quantidade/Limite',
  number: 'Quantidade',
  quota: 'Limite',
  price: 'Preço Unitário',
  paymentMethod: 'Método de Pagamento',
  trade: 'Negociação',
  handlingFee: '0% de Taxa',
  buyUsdt: 'Comprar USDT',
  sellBtc: 'Vender USDT',
  theRemainingAmount: 'Quantidade Restante',
  userRealName: 'Nome Real do Usuário',
  businessMessage: 'Mensagem do Comerciante',
  wantPay: 'Eu Quero Pagar',
  wantSell: 'Eu Quero Vender',
  receive: 'Eu Receberei',
  password: 'Senha',
  pleaseEnterPassword: 'Por favor, insira a senha',
  cancel: 'Cancelar',
  buyUSDT: 'Comprar USDT',
  sellUSDT: 'Vender USDT',
  Paymentchannel :'Canal de pagamento (consulte a taxa de câmbio do provedor de serviços).',
  lumpSum: 'Total',
  agree: 'Se você concorda em fazer negociações C2C com a CoinKing, isso significa que você aceita o',
  mzsm: 'Aviso Legal da Negociação C2C da CoinKing',
  quit: 'Sair',
  confirm: 'Confirmar',
  orderDetail: 'Detalhes do Pedido',
  limitExceeded: 'Limite Excedido',
  quantityRemaining: 'Quantidade Restante Insuficiente',
  
  cryptoTitle: 'Compre USDT em poucos passos fáceis',
  cryptoSubTitle: 'Plataforma de negociação de ativos digitais de contrato líder em segurança global',
  availableBalance: 'Saldo Disponível',
  sellAll: 'Vender Tudo',
  fundsTransfer: 'Transferência de Fundos',
  threeStep: 'Apenas três passos para comprar moedas',
  advantage: 'Vantagens de escolher a CoinKing para comprar e vender criptomoedas',
  commonQuestion: 'Perguntas Comuns',
  otc_title: 'Compre/venda criptomoedas usando taxa C2C 0',
  otc_title1: "Realize transações sem taxa com segurança e facilidade no BiKing. Negocie USDT instantaneamente por meio de transferência bancária, cartão de crédito e outros métodos de pagamento",
  commonQuestion1: 'O que é a negociação de criptomoedas C2C?',
  commonQuestion2: 'Quais são os custos das transações C2C?',
  commonQuestion3: 'O que são os comerciantes na BiKing C2C?',
  commonQuestion4: 'Os comerciantes C2C da BiKing podem obter lucro?',
  commonQuestion5: 'Como evitar fraudes C2C?',
  commonQuestion1_desc: "A negociação de criptomoedas C2C refere-se a transações de criptomoedas de ponto a ponto, onde os usuários podem trocar criptomoedas diretamente entre si sem a necessidade de intermediários, como bolsas centralizadas.",
  commonQuestion2_desc: "Os custos das transações C2C podem variar significativamente com base na plataforma, nas criptomoedas específicas envolvidas e na congestão de rede durante a transação. No entanto, a BiKing C2C não cobra taxas para transações de criptomoedas, eliminando a necessidade de intermediários.",
  commonQuestion3_desc: "Os comerciantes na BiKing C2C são usuários verificados que podem publicar anúncios de negociação na plataforma e realizar transações com outros usuários.",
  commonQuestion4_desc: "A lucratividade dos comerciantes C2C da BiKing depende de vários fatores, incluindo suas estratégias de negociação, frequência de transações, spreads de compra e venda e condições gerais do mercado.",
  commonQuestion5_desc: "Para evitar fraudes C2C, é aconselhável verificar a identidade da contraparte, usar plataformas seguras, limitar o compartilhamento de dados pessoais ou financeiros e utilizar métodos de pagamento rastreáveis.",
  register: 'Registrar',
  registerByPhone: 'Registrar por E-mail ou Número de Celular',
  authentication: 'Autenticação',
  authenticationId: 'Conclua a autenticação de identidade com apenas um documento de identidade',
  buyCoins: 'Comprar Moedas',
  buyCoinsByCard: 'Comprar moedas com cartão de crédito, débito ou transferência bancária',
  fast: 'Rápido e Conveniente',
  easyUse: 'Compra de moedas fácil',
  fastPayment: 'Leva apenas alguns minutos para receber os fundos rapidamente.',
  multiplePayment: 'Vários métodos de pagamento',
  platformSupports: 'A plataforma suporta diversos métodos de pagamento',
  flexibleConvenient: 'Proporcionando maior flexibilidade e comodidade aos usuários.',
  safeReliable: 'Seguro e Confiável',
  measure: 'Utiliza múltiplas tecnologias e medidas de segurança',
  informationSecurity: 'Garante a segurança dos fundos e informações dos usuários.',
  questionTitle1: '1. Introdução à CoinKing Exchange',
  questionSubTitle1: 'A CoinKing Exchange é uma plataforma global líder em negociação de ativos digitais de Cingapura, com licenças MSB dos EUA/Canadá, oferecendo serviços de negociação, armazenamento, gestão e mais para várias criptomoedas.',
  questionTitle2: '2. Quais produtos a CoinKing Exchange oferece?',
  questionSubTitle2: 'A CoinKing Exchange oferece os seguintes produtos: Contratos Perpétuos - profundidade superior, correspondência rápida; Negociação Spot - 0 taxas, negociação rápida; Comunidade de Seguidores - traders experientes, estratégias estáveis; Negociação com Bônus - modelo exclusivo, benefícios contínuos; Carteira Web - serviço integrado descentralizado.',
  questionTitle3: '3. Como se registrar na CoinKing Exchange?',
  questionSubTitle3: 'Você pode se registrar na CoinKing Exchange por meio do site oficial ou do aplicativo CoinKing. Clique em "Registrar" e conclua o processo de registro para começar a investir e gerenciar criptomoedas na CoinKing Exchange.',
  questionTitle4: '4. Como comprar criptomoedas na CoinKing Exchange?',
  questionSubTitle4: 'A CoinKing Exchange oferece uma maneira rápida de comprar criptomoedas, com suporte para vários métodos de pagamento e várias moedas fiduciárias. Isso proporciona aos usuários globais mais opções e conveniência, permitindo que eles comprem criptomoedas usando sua moeda local.',
  questionTitle5: '5. Como realizar transações de ativos digitais?',
  questionSubTitle5: 'Na CoinKing Exchange, você pode selecionar o ativo digital que deseja negociar, acessar a página de negociação, escolher comprar ou vender, inserir a quantidade e o preço da transação e confirmar a transação. A CoinKing Exchange suporta diversos ativos digitais para negociação, incluindo Bitcoin, Ethereum, Litecoin, Ripple, entre outros.',
  questionTitle6: '6. Como a CoinKing Exchange protege os ativos dos usuários?',
  questionSubTitle6: 'A CoinKing Exchange utiliza tecnologias de criptografia avançadas para proteger as informações e os ativos dos usuários. Além disso, ela adota uma abordagem de armazenamento a frio e a quente separado para garantir a segurança dos ativos dos usuários.',

  orderType: 'Tipo de Pedido',
  orderStatus: 'Status do Pedido',
  to: 'Até',
  startTime: 'Data de Início',
  endTime: 'Data de Término',
  orderNo: 'Número do Pedido',
  status: 'Status',
  totalPrice: 'Preço Total',
  numberOrFee: 'Quantidade de Transação / Taxa',
  tradingPartners: 'Contraparte da Negociação',
  time: 'Hora',
  operate: 'Operação',
  details: 'Detalhes',
  noPay: 'Aguardando Pagamento',
  payed: 'Pago',
  finish: 'Concluído',
  canceled: 'Cancelado',
  complaint: 'Em Disputa',
  legalCurrency: 'Valor em Moeda Fiat',
  virtualCurrency: 'moeda digital',
  virtualCurrencyAddress: 'Endereço de pagamento',
  paymenttype: 'Tipo de pagamento',
  creatTime: 'Data de Criação',
  success: 'Sucesso',
  pending: 'Pendente',
  awaiting: 'Aguardando Confirmação',
  declined: 'Recusado',
  deposittokens:'Ordem de venda aguardando o usuário depositar tokens',
  makepayment:'Ordem de compra aguardando o usuário pagar',
  verification:'Identidade do usuário a ser verificada',
  Transactioncancelled:'Transação cancelada',
  Transactionrejected:'Transação rejeitada',
  mjskfs: 'Formas de Pagamento do Vendedor',
  mjfkfs: 'Formas de Pagamento do Comprador',
  toPay: 'Pagar Agora',
  ddzdqx: 'Se você não selecionar uma forma de pagamento em {payTime}, o pedido será cancelado automaticamente.',
  paying: 'O comprador está fazendo o pagamento...',
  fkckh: 'Número de Referência do Pagamento:',
  dfwfkqx: 'Se o comprador não efetuar o pagamento em {payTime}, o pedido será cancelado automaticamente.',
  ddqxwfck: 'O pedido foi cancelado e as informações de pagamento não estão disponíveis.',
  ddqxckh: 'O pedido foi cancelado. Número de Referência do Pagamento:',
  ssz: 'Em disputa, por favor, aguarde. Número de Referência do Pagamento:',
  qxss: 'Cancelar Disputa',
  xzfkfs: 'Forma de Pagamento Selecionada',
  ddywc: 'Pedido Concluído',
  ss: 'Disputar',
  wcfqss: '* Você só pode abrir uma disputa 1 minuto após a conclusão do pedido.',
  bnfqss: '* Você não pode abrir uma disputa após {time} horas de conclusão do pedido.',
  zxkf: '* Após a compra OTC, é necessário esperar um dia útil para poder sacar. Em caso de dúvida, entre em contato com o suporte.',
  sjyjn: 'O vendedor já depositou uma caução de {deposit} {depositName}',
  wen1: '1. Quando receberei o pagamento?',
  da1: 'Você receberá uma notificação assim que o comprador concluir o pagamento.',
  wen2: '2. E se o comprador não efetuar o pagamento após fazer o pedido?',
  da2: 'O vendedor não pode cancelar o pedido, mas se o tempo de espera for muito longo, você pode abrir uma disputa e nossa equipe de suporte irá ajudá-lo.',
  wen3: '3. O que acontece se eu não liberar os ativos digitais a tempo?',
  da3: 'Se você não confirmar o recebimento a tempo, o comprador pode abrir uma disputa, o que pode afetar sua reputação na plataforma. Além disso, seus ativos permanecerão congelados na sua carteira da plataforma até o problema ser resolvido.',
  wen4: '4. Observações sobre Recebimento de Pagamentos',
  da4: '1) Por favor, verifique repetidamente se você realmente recebeu o pagamento do comprador. Não confie em qualquer pedido para liberar os ativos digitais antes de ter certeza de que recebeu o pagamento. Isso evitará perdas de ativos digitais! <br/>2) Se a conta bancária do comprador não estiver em nome do titular da conta da plataforma, esteja ciente do risco de recebimento. Se tiver alguma dúvida, abra uma disputa imediatamente.',
  qzgdsjnzf: 'A pagar, por favor, pague {totalAmounts} {fiatCurrency} a {associatedAdMerchantNickname} dentro de {payTime}, Número de Referência do Pagamento:',
  nxdfgm: 'Você está comprando {amount_s} {coinsName} de {associatedAdMerchantNickname} ({realName})',
  dfxngm: '{userNickName} ({realName}) está comprando {amount_s} {coinsName} de você',
  nxdfcs: 'Você está vendendo {amount_s} {coinsName} para {associatedAdMerchantNickname} ({realName})',
  dfxncs: '{userNickName} ({realName}) está vendendo {amount_s} {coinsName} para você',
  payed: 'Pago',
  dddffx: 'Aguardando a liberação do vendedor...',
  njhdq: 'Você receberá {quantity} {coinsName}',
  qxdd: 'Cancelar Pedido',
  kfqss: 'Após {complaintPayed} minutos desde o pagamento, se o vendedor não liberar os ativos digitais, você pode abrir uma disputa',
  yfkfkckh: 'O comprador já efetuou o pagamento. Número de Referência do Pagamento:',
  qjkqrsk: 'Por favor, confirme o recebimento o mais rápido possível',
  ddnsk: 'Aguardando o recebimento do pagamento de você',
  zfje: 'Valor do Pagamento',
  skzh: 'Conta para Recebimento:',
  fkzhxm: 'Nome da Conta de Pagamento:',
  qdskh: '* Por favor, certifique-se de que recebeu o pagamento antes de confirmar o recebimento em suas ferramentas de pagamento',
  fbl: 'Liberar Ativos',
  dfyqrfk: '* O comprador já confirmou o pagamento. Se você não tiver recebido o valor real em {complaintPayed} minutos, você pode abrir uma disputa',
  jkcssk: '* Depois que o comprador confirmar o pagamento por mais de 24 horas, você não poderá abrir uma disputa. Por favor, verifique o recebimento o mais rápido possível',
  qrfb: 'Confirmar Liberação de Ativos',
  qwbqr: 'Por favor, confirme que já recebeu o pagamento deste pedido e que o valor está correto antes de liberar os ativos',
  wyqrskzq: 'Confirmo que recebi o pagamento e que o valor está correto',
  tjssyy: 'Por favor, forneça o motivo da disputa',
  srssyy: 'Por favor, insira o motivo da disputa',
  sctpxt: 'Enviar Fotos (opcional)',
  upload: 'Enviar',
  zdscsz: '* Você pode enviar até três imagens, nos formatos JPEG, JPG ou PNG, com um tamanho máximo de 3 MB cada.',
  sstj: 'Enviar',
  qrfk: 'Confirmação de Pagamento',
  fkje: 'Valor do Pagamento',
  sdzz: '*A plataforma não suporta débito automático. Por favor, transfira o valor para a conta acima a partir da sua própria conta. Após a transferência ser concluída, clique em pagamento. Se o botão de pagamento não for clicado após a transferência, quaisquer perdas resultantes serão de sua responsabilidade.',
  bzts: '*Por favor, não inclua informações como BTC, USDT ou BiKing nas observações ao transferir, caso contrário, o vendedor poderá recusar.',
  wfk: 'Não Pago',
  w: 'Eu',
  srxxfs: 'Digite as informações, pressione Enter para enviar',
  dan: 'único',
  bnch: 'Não é possível adicionar o mesmo tipo de método de pagamento',
  sd:'Swap',
  from:'Pagar',
  to:'Obter',
  rate:'Taxa de câmbio',
  fees:'Taxa',
  slippage:'Deslizamento',
  standards:'Padrão de cobrança da taxa de manuseamento',
  transactionamount:'{num} do valor da transação',
  confirm:'Confirmar',
  records:'Todos os registos',
  chaeckrecords:'Ver todos os registros de resgate flash》',
  tocurrency:'Moeda consumida',
  consumption:'Quantidade consumida',
  Getcurrency:'Obter moeda',
  GetQuantity:'Obter quantidade',
  ExchangeStatus:'Estado de troca',
  Exchangetime:'Tempo',
  Youwillconsume:'Vai consumir',
  YouwillGET:'Vai conseguir',
  Updatequote:'Atualizar cotação',
  Failed:'Falha na troca',
  Consumption:'Canais de consumo',
  Completed:'Concluído',
  successful:'Resgate bem-sucedido',
  Converted:'Você converteu {aaa} em {bbb} com sucesso',
  recommend:'Recomendar',
  wcsj: "Hora de Conclusão"
}

const otcMerchant = {
  bzj: 'Depósito',
  mmggs: 'Número de anúncios de compra e venda',
  bx: 'Ilimitado',
  ggzed: 'Valor total do anúncio',
  kzjgged: 'Valor adicional do anúncio',
  zjbzjbs: 'Múltiplo do depósito adicional',
  tbzss: 'Exibição síncrona de 10 itens',
  tjsjsqb: 'Enviar Formulário de Solicitação de Empresa',
  wcgjkycrz: 'Concluir a Verificação Avançada de KYC',
  ynlx: 'Após a revisão do formulário, um especialista em OTC entrará em contato com você prontamente',

  zbzl: 'Prepare seus documentos',
  kssh: 'Aprovação rápida',

  h1: 'Negociação inteligente',
  h2: 'Torne-se um especialista em negociações C2C',
  h3: 'Em breve, será um comerciante certificado',
  sjqy: 'Benefícios do comerciante',
  c2cjy: 'Além de negociações C2C com <span>0 taxa</span>, também oferecemos muitos outros benefícios para os comerciantes.',
  fbq: 'Sua área de negociação com moedas fiduciárias',
  ptsj: 'Comerciante comum',
  xsqy: 'Torne-se um comerciante certificado e desfrute de mais benefícios',
  wtd: 'Após a aprovação, você poderá publicar pedidos de negociação',
  xjn: 'Você precisa pagar uma garantia de {deposit}',
  ljsq: 'Solicite agora',
  cwptsj: 'Você já é um comerciante comum',
  cwrzsj: 'Você já é um comerciante certificado',
  rzsj: 'Comerciante Certificado',
  xrd: 'Desfrute da maior confiança do mercado de negociação',
  nbyq: 'Somente convites internos da Biking',
  rzbs: 'Identificação exclusiva de comerciante certificado',
  pmq: 'Obtenha prioridade nas classificações',
  kffw: 'Aproveite o serviço de atendimento ao cliente 1 a 1',
  sjxy: 'Contrato Comercial OTC',
  xsjc: 'Tutorial para iniciantes',
  jygz: 'Regras de negociação',
  close: 'Fechar',
  submited: 'Já enviei',
  submitSuccess: 'Enviado com sucesso',

  sqsj: 'Solicitar ser um comerciante',
  fwxy: 'Termos de Serviço para Comerciantes Biking Coin King',
  xyb: 'A Biking Coin King é uma plataforma especializada em negociações de ativos digitais e na prestação de serviços relacionados. Para facilitar a redação deste acordo, a empresa e o site serão referidos conjuntamente como "nós" ou por outros pronomes em primeira pessoa do singular. Qualquer pessoa física ou entidade que se registre e faça login no site será considerada um usuário deste site. Para fins de facilidade na redação deste acordo, usaremos "você" ou outros pronomes em segunda pessoa do singular. Para facilidade na redação deste acordo, "nós" e "você" serão referidos conjuntamente como "ambas as partes" e individualmente como "uma parte".',
  ptsm: 'Declaração da Plataforma:',
  p1: '1. Este site serve apenas como um local para fornecer informações de negociação de ativos digitais e consultas sobre negociação de ativos digitais. O site não participa de nenhuma negociação substancial de ativos digitais. Portanto, as partes envolvidas na negociação devem julgar com cuidado a autenticidade, legalidade e efetividade das informações e/ou ativos digitais relacionados e assumir total responsabilidade e perdas decorrentes disso.',
  p2: '2. Todas as opiniões, notícias, discussões, análises, preços, sugestões e outras informações neste site são apenas comentários de mercado em geral e não constituem aconselhamento de investimento. Não nos responsabilizamos por quaisquer perdas decorrentes do uso direto ou indireto dessas informações, incluindo, mas não se limitando a, quaisquer perdas de lucros.',
  p3: '3. O conteúdo deste site está sujeito a alterações sem aviso prévio. Fizemos esforços razoáveis para garantir a precisão das informações no site, mas não podemos garantir o grau de precisão e não nos responsabilizamos por perdas diretas ou indiretas causadas por informações no site ou atrasos ou falhas na transmissão ou recepção de notificações e informações via internet.',
  p4: '4. O uso de sistemas de negociação baseados na internet também envolve riscos, incluindo, mas não se limitando a, falhas de software, hardware e conexão à internet. Como não podemos controlar a confiabilidade e a disponibilidade da internet, não nos responsabilizamos por distorções, atrasos e falhas de conexão.',
  p5: '5. É proibido o uso deste site para atividades comerciais ilegais, como lavagem de dinheiro, contrabando, suborno comercial, ou qualquer outra atividade ilegal. Se qualquer atividade suspeita de ilegalidade for detectada, tomaremos várias medidas, incluindo, mas não se limitando a, congelamento de contas, notificação de autoridades relevantes, e não assumiremos nenhuma responsabilidade decorrente disso, reservando o direito de responsabilizar os envolvidos.',
  p6: '6. É proibido o uso deste site para manipulação de mercado ou quaisquer outras atividades comerciais antiéticas. Se tal comportamento for detectado, tomaremos medidas preventivas, como advertências, restrição de negociações, encerramento de contas, etc., e não assumiremos nenhuma responsabilidade decorrente disso, reservando o direito de responsabilizar os envolvidos.',
  p7: 'Ao concordar com os Termos de Serviço da Biking Coin King, você também concorda com todas as declarações da plataforma. Este acordo é celebrado entre você e os operadores da Biking Coin King e tem plena força de contrato.',
  zcbzj: 'Artigo 1: Garantia de Ativos',
  p8: '1. Após o comerciante passar pela verificação KYC e anti-lavagem de dinheiro da plataforma, a plataforma solicitará que o comerciante deposite uma quantia de garantia em sua conta da plataforma para garantir a segurança e a fluidez de suas transações na plataforma.',
  p9: '2. O valor específico da garantia será exibido nos ativos em moeda fiduciária do comerciante na plataforma e também será exibido durante o processo de negociação para os usuários.',
  p10: '3. Caso ocorram as seguintes situações, a plataforma terá o direito de apreender a garantia do comerciante e tomar outras medidas adequadas. A garantia será retida por pelo menos 1 mês, e, se for determinado que causou perdas à plataforma e aos usuários, a garantia será deduzida proporcionalmente.',
  p11: '1) O comerciante se envolve em disputas durante a negociação e é considerado responsável e obrigado a cumprir obrigações relevantes, mas se recusa a cooperar;',
  p12: '2) O comerciante realiza transações com contas não verificadas na plataforma;',
  p13: '3) O comerciante utiliza a plataforma para atividades ilegais;',
  p14: '4) O comerciante viola este acordo ou qualquer outro documento legal ou regra de negociação no site;',
  p15: '5) O comerciante é suspeito de direcionar os usuários para outras plataformas;',
  p16: '6) O comerciante é suspeito de induzir o registro falso de usuários para obter recompensas de promoção na plataforma;',
  p17: '7) O comerciante é suspeito de influenciar indevidamente os usuários parceiros da plataforma a realizar transações em outras plataformas.',
  cxzg: 'Artigo 2: Revogação da Qualificação de Comerciante',
  p18: 'Se ocorrerem as seguintes situações, a plataforma terá o direito de revogar unilateralmente a qualificação de comerciante:',
  p19: '1. O comerciante é repetidamente denunciado por outros usuários da plataforma durante a negociação;',
  p20: '2. As informações fornecidas no pedido de certificação contêm informações falsas;',
  p21: '3. O comerciante se envolve em comportamentos fraudulentos ou outras ações desonestas durante a negociação;',
  p22: '4. O comerciante não coopera com o atendimento ao cliente da plataforma no processamento de pedidos ou atrasa intencionalmente o processamento dos pedidos;',
  p23: '5. O comerciante utiliza indevidamente as regras da plataforma para obter lucro;',
  p24: '6. O comerciante viola leis e regulamentos, este acordo, ou quaisquer outros documentos legais ou regras do site;',
  p25: '7. O comerciante se envolve em qualquer comportamento que a plataforma considere antiético ou que viole a ordem pública e a equidade das transações;',
  p26: '8. Outras ações que violam a lei e regulamentos.',
  zlbh: 'Artigo 3: Proteção dos Dados dos Comerciantes',
  p27: '1. Gestão dos dados dos comerciantes: Os dados de certificação fornecidos por você ao solicitar a certificação (incluindo informações de certificação anterior) serão irreversivelmente autorizados a serem mantidos pelo site. Comprometemo-nos a não divulgar, editar ou divulgar suas informações de certificação, salvo em circunstâncias legais ou acordadas, e não usaremos conteúdos não públicos armazenados no site para fins comerciais, exceto nas seguintes circunstâncias: Sua autorização para divulgação de informações relevantes pelo site;',
  p28: '2. Fornecimento ao governo e órgãos judiciais;',
  p29: '3. Fornecimento a empresas afiliadas ao site;',
  p30: '4. Quando o site e terceiros fornecem serviços aos usuários juntos, o terceiro fornece informações relevantes necessárias para fornecer serviços a você;',
  p31: '5. Quando necessário para resolver disputas civis com terceiros, o site tem o direito de fornecer suas informações de identidade a esse terceiro.',
  sjcn: 'Artigo 4: Compromisso do Comerciante',
  p32: '1. Aceitar todos os termos deste acordo é um pré-requisito para solicitar a certificação.',
  p33: '2. Você declara e garante que não solicitará a certificação para qualquer finalidade ilegal ou proibida por este acordo.',
  p34: '3. Você não pode usar o serviço de solicitação de certificação de forma que possa prejudicar, inutilizar, sobrecarregar ou danificar o site ou qualquer serviço ou interferir no uso do site por outros meios não relacionados ao site.',
  p35: '4. Você não pode obter ou tentar obter informações ou materiais de qualquer forma não fornecida pelo site.',
  p36: '5. Você reconhece e concorda que o uso deste site para negociação de ativos digitais não é para fins de violação de leis e regulamentos ou de perturbar a ordem de negociação de ativos digitais no site.',
  p37: '6. O comerciante concorda em cumprir os requisitos de divulgação de todas as informações de negociação estabelecidos pela plataforma e fornecer documentos, materiais ou informações conforme solicitado pela plataforma. Se o comerciante se recusar a fornecer os documentos, materiais ou informações solicitados pela plataforma, a Parte B tem o direito de tomar a decisão de revogar a qualificação de comerciante, dependendo da situação.',
  ptmz: 'Artigo 5: Isenção de Responsabilidade da Plataforma',
  bcfx: 'A plataforma não será responsabilizada nas seguintes situações:',
  p38: '1. A divulgação de suas informações pessoais devido à divulgação da sua senha a outras pessoas, falha na proteção adequada da sua senha, compartilhamento da conta com outras pessoas ou qualquer outra falha sua, e as consequentes perdas;',
  p39: '2. Quaisquer perdas decorrentes de ataques de hackers, invasões ou ataques de vírus de computador, ajustes técnicos feitos pelo departamento de telecomunicações que afetem o funcionamento do site, fechamento temporário devido a regulamentações governamentais, perdas causadas por quaisquer outras razões (incluindo, mas não se limitando a, falhas nas principais linhas internacionais de exportação, falhas de provedores de telecomunicações internacionais, incêndios, inundações, raios, terremotos, inundações, tufões, erupções vulcânicas, epidemias e pandemias de doenças infecciosas, greves, guerra ou atos violentos ou eventos semelhantes);',
  p40: '3. Quaisquer perdas decorrentes do uso indevido de informações bancárias causado pelo link para outros sites (como bancos online, etc.) relacionados neste site. ',
  p41: '4. Quaisquer perdas decorrentes de fornecimento de informações incorretas, incompletas ou falsas por você durante o uso do site, etc., que não sejam atribuíveis ao site;',
  p42: '5. Quaisquer perdas de ativos devido a fraude cometida por terceiros.',
  ptts: 'Artigo 6: Notificação da Plataforma',
  p43: '1. Para realizar a verificação de informações de identidade, este site pode conter links para sites de terceiros (como sites bancários online) (a seguir denominados "sites de links"). Os "sites de links" não são controlados por este site e não somos responsáveis por nenhum conteúdo de qualquer "site de links", incluindo, mas não se limitando a, qualquer link contido em um "site de links" ou quaisquer mudanças ou atualizações em um "site de links". Este site não se responsabiliza pela propagação via internet ou de outra forma do material recebido de qualquer "site de links".',
  p44: '2. Este site fornece apenas serviços de plataforma de negociação de ativos digitais para suas atividades de negociação (incluindo, mas não se limitando a, serviços de negociação de ativos digitais). O site não atua como comprador ou vendedor envolvido em transações de ativos digitais. O site não fornece serviços relacionados a depósitos ou retiradas de moeda fiduciária.',
  p45: '3. Assim que você fizer login neste site, usar qualquer serviço deste site ou realizar qualquer outra ação semelhante, você reconhece que compreende e concorda plenamente com todos os termos deste acordo, incluindo quaisquer modificações feitas a este acordo, conforme anunciado no site, e o acordo será efetivo imediatamente após ser anunciado no site.',
  p46: '4. Ao usar o site e seus serviços de qualquer forma autorizada pelo site, ou ao clicar em qualquer botão que indique "Aceitar" ou de forma semelhante, ou ao usar de outra forma os serviços fornecidos pelo site, você declara que compreende, concorda e aceita todas as disposições deste acordo, e que o acordo é vinculativo para você, independentemente de ter assinado este acordo manualmente.',
  p47: '5. Reservamos o direito de revisar este acordo a qualquer momento e anunciar tais revisões no site, sem a necessidade de notificá-lo separadamente. O acordo revisado entrará em vigor imediatamente após ser anunciado no site e indicar a data da revisão.',
  tyxy: 'Eu concordo com o conteúdo deste acordo',
  nextStep: 'Próximo Passo'
}

const user = {
  txxz: 'Alteração de senha de fundos: 24 horas sem saque',
  name: 'Nome de usuário',
  rzdj: 'Nível de autenticação de identidade',
  phone: 'Telefone',
  email: 'E-mail',
  zzc: 'Valor total dos ativos',
  hours24: '24 horas',
  market: 'Mercado',
  notice: 'Avisos',
  more: 'Mais >>',
  cb: 'Depósito',
  tb: 'Retirada',
  hz: 'Transferência',
  wsm: 'Não verificado',
  cjrz: 'Autenticação Inicial',
  gjrz: 'Autenticação Avançada',
  qwgjrz: "Ir para Verificação Avançada",
  aqszx: 'Configurações de Segurança Completas',
  xgaqszx: 'Alterar Suas Configurações de Segurança',
  dlmm: 'Senha de login',
  zjdl: 'Configurando uma senha de login, você poderá acessar sua conta com seu nome de usuário e senha de login',
  ghmm: 'Alterar senha',
  sz: 'Configuração',
  jymm: 'Senha de transação',
  yzjymm: 'Quando houver mudanças nos fundos da conta, será necessário validar a senha de transação.',
  ghjymm: 'Alterar senha de transação',
  sjyz: 'Verificação do telefone',
  yzdx: 'Receber SMS de verificação para login, retirada, alteração de senha e configurações de segurança',
  xgsj: 'Alterar número do telefone',
  zwbd: 'Não vinculado',
  ggyz: 'Verificação Google',
  syzn: 'Guia de Uso',
  bd: 'Vincular',
  yxyz: 'Verificação do e-mail',
  tbqr: 'Você pode vincular um e-mail comum para confirmações durante o login, recuperação de senha e retiradas',
  bdyx: 'Vincular e-mail',
  xgyx: "Modificar e-mail",
  xyx: "Novo e-mail",
  dljl: 'Últimos 10 registros de login',
  zjdljl: 'Estes são os seus 10 registros de login mais recentes',
  dlsj: 'Hora de login recente',
  ip: 'Endereço IP',
  aqsz: 'Configurações de Segurança',
  yhdl: 'Login do usuário',
  xgbdsj: 'Alterar número de telefone vinculado',
  bdsj: 'Vincular número de telefone',
  dxyzm: 'Código de verificação SMS',
  second: 'segundos',
  fsyzm: 'Enviar',
  xsjh: 'Novo número de telefone',
  ggyzm: 'Código de verificação Google',
  yxyzm: 'Código de verificação de e-mail',
  confirm: 'Confirmar',
  edit: 'Editar',
  name: 'Nome',
  srxm: 'Insira o nome',
  zjlx: 'Tipo de documento',
  xzzjlx: 'Selecione o tipo de documento',
  zjhm: 'Número do documento',
  srzjhm: 'Insira o número do documento',
  zcsr: 'Confirme a senha',
  mmbyz: 'As senhas digitadas não coincidem!',
  sfz: 'Carteira de identidade',
  jgz: 'Identidade militar',
  hz: 'Passaporte',
  jmtxz: 'Permissão de entrada para residentes de Taiwan',
  gatxz: 'Permissão de entrada para residentes de Hong Kong e Macau',
  hwid: 'ID no exterior',
  srdx: 'Insira o código de verificação SMS',
  sryx: 'Insira o código de verificação de e-mail',
  srgg: 'Insira o código de verificação Google',
  jdlmm: 'Senha de login antiga',
  xdlmm: 'Nova senha de login',
  qrxmm: 'Confirme a nova senha',
  qrdlmm: 'Confirme a senha de login',
  jjymm: 'Senha de transação antiga',
  xjymm: 'Nova senha de transação',
  qrjymm: 'Confirme a nova senha de transação',
  qwcyz: 'Por favor, complete a verificação',
  smrz: 'Por favor, faça a autenticação de identidade primeiro',
  sryzm: 'Por favor, insira o código de verificação',
  srsjh: 'Por favor, insira o número de telefone',
  xgdlmm: 'Alterar senha de login',
  szdlmm: 'Configurar senha de login',
  xgjymm: 'Alterar senha de transação',
  szjymm: 'Configurar senha de transação',
  czmm: 'Redefinir senha',
  
  bdgg: 'Vincular Autenticador Google',
  lbyzq: 'Por favor, faça o download do Autenticador Google',
  smewm: 'Digitalize o código QR com o Autenticador Google',
  srdm: 'Se o código QR não puder ser reconhecido, insira o código abaixo manualmente',
  copy: 'Copiar',
  copySuccess: 'Copiado com sucesso',
  sryx: 'Por favor, insira o e-mail',
  srzqyx: 'Por favor, insira um endereço de e-mail válido',
  srsjyzm: 'Por favor, insira o código de verificação de SMS',
  sryxyzm: 'Por favor, insira o código de verificação de e-mail',
  srggyzm: 'Por favor, insira o código de verificação do Google',
  passwordTypeError: 'Formato de senha incorreto. A senha deve conter entre 8 e 32 caracteres, incluindo letras maiúsculas, minúsculas e números.',
  passwordDiff: 'As senhas digitadas não coincidem',
  zcsrxmm: 'Por favor, insira a senha novamente',
  language: 'Idioma',
  bdhb: 'Moeda Local',
  wdbph: 'Preferência de Moeda Estável',
  "相关问题": "Questões Relacionadas",
  "为什要进行身份认证": "Por que fazer autenticação de identidade",
  "上传中": "Enviando...",
  "开始上传": "Iniciar o Upload",
  "请手持身份证正面": "Por favor, segure a frente do seu documento de identidade abaixo do rosto",
  "正对摄像头": "Fique de frente para a câmera, mantenha por pelo menos 5 segundos",
  "摘下眼镜": "Retire os óculos, chapéu ou outras obstruções",
  "请按视频文字提示录制视频": "Siga as instruções na tela para gravar o vídeo",
  "开始录制": "Iniciar Gravação",
  "第一段视频": "Primeiro Segmento de Vídeo",
  "第二段视频": "Segundo Segmento de Vídeo",
  "录制一段视频": "Gravar um segmento de vídeo",
  "点击开始录制": "Clique para iniciar a gravação",
  "视频录像认证": "Autenticação por Gravação de Vídeo",
  "身份证号": "Número do Documento de Identidade",
  证件验证: "Verificação de Documento (Foto/Escaneamento)",
  zjyz: "Verificação de Documento",
  "请确保图片格式为": "Certifique-se de que o formato da imagem seja jpg/jpeg/png. Certifique-se de que o tamanho da imagem seja inferior a 2 MB",
  "请手持证件照": "Segure a foto do documento de identidade e a assinatura pessoal. A assinatura deve incluir 'Biking' e a data atual",
  "当日签名照": "Foto do documento de identidade + assinatura do dia",
  "上传证件签名页": "Faça o upload da página de assinatura do documento de identidade",
  "请保证所有信息清晰": "Certifique-se de que todas as informações estejam claras",
  "上传证件页信息": "Faça o upload da página de informações do documento de identidade",
  "请选择国家": "Selecione o País",
  "请选择区域": "Selecione a Região",
  "认证要求": "Requisitos de Autenticação",
  "证件信息": "Informações do Documento de Identidade",
  "人脸识别": "Reconhecimento Facial",
  "立即认证": "Autenticar Agora",
  "什么是加密货币P2P交易": "O que é a negociação de criptomoedas P2P",
  "最好的P2P加密货币交易所是什么": "Qual é a melhor exchange P2P de criptomoedas",
  "P2P交易的成本有多少": "Qual é o custo da negociação P2P",
  "什么是BikingP2P上的商家": "O que são os comerciantes no Biking P2P",
  "我们正在审核您的申请": "Estamos revisando a sua solicitação",
  "预计审核时间": "Tempo estimado de revisão: 72 horas",
  "驳回": "Rejeitado",
  "未提交": "Não Enviado",
  "手续费等级": "Níveis de Taxa",
  "去认证": "Ir para Autenticação",
  "开通更多权限": "Autentique a identidade para desbloquear mais privilégios",
  "在别人贪婪时要保持警惕": "Seja cauteloso quando os outros estão gananciosos e seja ganancioso quando os outros estão cautelosos",
  'kyc声明': 'Eu sou {Name}, e meu número de identificação é: {No}. Eu me registro e realizo transações voluntariamente na Biking, garantindo que a conta seja usada por mim. Eu garanto que todos os ativos têm origem legal, e compreendo e posso suportar todos os riscos da transação. Os ativos digitais extraídos não serão usados para fins ilegais, e eu não participarei de atividades ilegais nesta plataforma, como lavagem de dinheiro, esquemas de pirâmide e câmbio ilegal de moeda.',
  编辑头像: "Editar foto de perfil",
  请选择一个头像用作您个人资料的照片: "Escolha uma foto para usar como sua imagem de perfil",
  中国: "China",
  其他: "Outro",
  questionTitle1: '1. Por que é necessário fornecer autenticação de identidade?',
  questionSubTitle1: 'A CoinKing utiliza um serviço global de verificação de identidade em conformidade com regulamentações, garantindo a segurança dos fundos de todos os usuários. Portanto, ao preencher as informações, certifique-se de fornecer os documentos necessários.',
  questionTitle2: '2. Quais são os benefícios de completar a autenticação de identidade?',
  questionSubTitle2: 'Todos os usuários devem concluir a autenticação de identidade para acessar a funcionalidade OTC da CoinKing. Os usuários que ainda não completaram a autenticação de identidade não são afetados pelos depósitos e retiradas na cadeia.',
  questionTitle3: '3. Como atualizar a autenticação de identidade?',
  questionSubTitle3: 'Se suas informações de identidade mudarem e atenderem aos seguintes critérios, você pode entrar em contato com o suporte online para solicitar a atualização da autenticação de identidade:',
  questionTitle4: '4. Quanto tempo leva para a autenticação KYC?',
  questionSubTitle4: 'As informações que você forneceu geralmente são verificadas em até 5 minutos. No entanto, em circunstâncias especiais, pode ser necessário mais tempo.',
  questionTitle5: '5. A autenticação de identidade da CoinKing é segura?',
  questionSubTitle5: 'A autenticação de identidade da CoinKing é segura e nos ajuda a construir uma plataforma segura para você e todos os outros usuários. Seus documentos também são mantidos em sigilo por nós.',
  questionTitles:'1. Documento expirado;',
  questionTitles1:'2. Nome no documento alterado;',
  questionTitles2:'3. Número de identificação no documento alterado;',
  questionTitles3:'4. Mudança de nacionalidade;',
  questionTitles4:'5. Atualizar documentos para uso normal da moeda fiduciária;',
  questionTitles5:'6. Alterar o nome reconhecido pelo sistema de idioma (por exemplo, de ID nacional para passaporte);',
  Z1001: "Erro de sistema",
  Z1003: "Verificação interrompida",
  Z2002: "Erro de rede",
  Z2003: "Erro de tempo do dispositivo do cliente",
  Z2006: "Autenticação falhou",
  Z5050: "Verificação facial bem-sucedida",
  Z5051: "Falha ao enviar a foto do rosto",
  Z5052: "Erro de dados ou exceção de programa",
  Z5053: "Erro de rede",
  Z5054: "Sem permissão de câmera ou falha ao obter dados da câmera",
  Z5055: "Usuário saiu",
  Z5056: "Muitas tentativas de retry",
  Z5057: "Tempo limite para upload do vídeo",
  Z5058: "Formato de vídeo não atende aos requisitos",
  Z5059: "Não há rosto válido no vídeo",
  Z5128: "A verificação não é da mesma pessoa",
  法币充值:'Limite de depósito e retirada de moeda fiduciária',
  无限额:'Sem limite',
  数字货币充值:'Depósito de criptomoedas',
  数字货币提现限额:'Limite de retirada de criptomoedas',
  C2C交易限额:'Limite de transação C2C',
  "参数不合法": 'Parâmetro inválido',
  h5smrz: "Autenticação de nome real",
  bhzhan: "Defina uma senha para proteger a segurança da sua conta",
  jxsmrz: "Realize autenticação de nome real para garantir a segurança dos fundos do usuário",
  qwrz: "Ir para Verificação",
  dgzhzd: "1. Uma conta individual pode ser enviada até 5 vezes por dia.",
  rhzp: "2. Quaisquer fotos, vídeos ou detalhes de documentos que você enviar não serão armazenados ou usados de forma alguma.",
  sfzm: "Comprovação de Identidade",
  zjqfg: "País Emissor do Documento",
  dw: "Posicionamento",
  sfxx: "Informação de Identidade",
  dqdw: "Localização Atual",
  gjdq: "País/Região"
}


const h5 = {
  chart: 'Gráfico',
  mmp: 'Livro de Ofertas',
  sscj: 'Negociações em Tempo Real',
  wt: 'Ordens',
  lswt: 'Histórico de Ordens',
  zj: 'Saldo',
  sj: 'Preço de Mercado',
  ky: 'Disponível',
  zczh: 'Valor Total dos Ativos',
  dj: 'Congelado',
  zwsj: 'Sem Dados Disponíveis',
  zx: 'Favoritos',
  buysell: 'Comprar/Vender'
}

const worldCup = {
  common: {
    cancel: 'Cancelar',
    confirm: 'confirmar',
    iKnow: 'Eu vejo',
    businessClosed: 'O serviço foi encerrado',
    points: 'integrante',
    day: 'céu',
    hour: 'Hora',
    minute: 'apontar',
    second: 'Segundo',
    noMatch: 'Sem partidas',
  },
  index: {
    liveFeed: 'dinâmica em tempo real',
    heroTitle: 'Apostando na Copa do Mundo',
    heroSplit: 'dividir',
    heroPrizePool: 'Conjunto de prêmios',
    heroMillionPrizePool: 'Divida o prêmio de 1 milhão',
    heroSub: 'Também há ingressos para Tesla e para a Copa do Mundo esperando por você.',
    heroJoinedPrefix: 'Já',
    heroJoinedSuffix: 'As pessoas estão participando e o prêmio continua a crescer.',
    activityTimeLabel: 'Tempo de atividade:',
    refreshing: 'Refrescante...',
    releaseToRefresh: 'Solte para atualizar imediatamente',
    pullToRefresh: 'Puxe para baixo para atualizar',
    livePrizePool: 'Prêmio em tempo real',
    growing: 'Crescendo em tempo real',
    userPoolRatioLabel: 'Usuários individuais podem compartilhar o prêmio:',
    teamPoolRatioLabel: 'As equipes podem compartilhar o prêmio:',
    poolCountdownLabel: 'Contagem regressiva para dividir o prêmio da fase {phase}',
    poolCountdownFinalLabel: 'Contagem regressiva para divisão do pool na fase final',
    poolActivityStartCountdownLabel: 'Até o início do evento',
    poolSplitDoneBadge: 'Distribuição do pool concluída',
    totalAllocatedPoolLabel: 'Pool total distribuído',
    poolAllocateFirst: '1ª distribuição',
    poolAllocateSecond: '2ª distribuição',
    poolAllocateThird: '3ª distribuição',
    poolAllocateFinal: 'Distribuição final',
    poolTeamPrefix: 'Equipe: ',
    poolPersonalPrefix: 'Individual: ',
    poolPersonalCount: 'Individual: {n} pessoas',
    teamTitle: 'Forme uma equipe e duplique sua renda',
    teamSubPrefix: 'Junte-se à equipe e tenha a oportunidade de melhorar',
    teamSubSuffix: 'renda',
    teamAgentTitle: 'Equipe de agentes',
    teamAgentDesc: 'Os agentes da plataforma podem formar uma equipe com um clique, e <span class="wc-hl"> pontos dos membros da equipe serão agregados ao total de pontos da equipe </span>. Ao mesmo tempo, concluir tarefas de equipe pode gerar <span class="wc-hl"> pontos de equipe adicionais </span>. Quanto mais pontos a equipe tiver, maior será a chance de <span class="wc-hl"> dividir o prêmio total </span>.',
    createTeamNow: 'Forme uma equipe agora',
    applyAgentNow: 'Não sou um agente, inscreva-se agora',
    teamUserTitle: 'equipe da liberdade',
    teamUserDesc: 'Não há necessidade de se tornar um agente, você pode ingressar em uma equipe gratuita, formar uma equipe com outros usuários gratuitos, participar de <span class="wc-hl2"> pontos de equipe</span> e obter <span class="wc-hl2"> oportunidades de compartilhamento de prêmios</span>.',
    joinNow: 'Cadastre-se agora',
    championTitle: 'Previsão do campeonato',
    championSub: 'Cada usuário só pode prever uma vez e não pode ser alterado após o bloqueio. Se o palpite estiver correto, você poderá compartilhar o prêmio individualmente.',
    championHintPrefix: 'Os usuários que preverem o vencedor correto receberão um prêmio',
    championHintSuffix: 'qualificações para dividir',
    championWin: 'Parabéns por adivinhar o vencedor',
    championLose: 'Desculpe, você não adivinhou corretamente',
    championWinSub: 'ganhe qualificação para dividir o prêmio individual.',
    championNoParticipation: 'O evento terminou, você não participou do palpite',
    confirmPredict: 'Confirmar previsão',
    predictCountdown: 'Contagem regressiva de previsão',
    predictEnded: 'A previsão foi encerrada',
    notice1: 'O usuário p***12 acabou de completar a aposta e ganhou 500 pontos',
    notice2: 'O usuário k***88 acabou de resgatar um Tesla',
    notice3: 'O usuário a***23 acabou de completar a aposta e ganhou 1.200 pontos',
    notice4: 'O usuário x***56 convidou amigos para ganhar 100 pontos',
    notice5: 'O usuário m***07 acabou de resgatar 1 ingresso para a Copa do Mundo',
    tabPredict: 'Apostas',
    tabTask: 'Tarefa',
    tabRank: 'classificação',
    tabExchange: 'intercâmbio',
    tabMine: 'meu',
    tabRules: 'regra',
  },
  toast: {
    refreshSuccess: 'Atualização bem-sucedida',
    predictSuccess: 'A aposta foi bem sucedida',
    inviteJumping: 'Vá para a página de convite...',
    applyAgentPending: 'A função de aplicação do agente está em desenvolvimento, fique atento!',
    championLocked: 'A previsão do campeonato está trancada!',
    exchangeSubmitted: 'O pedido de resgate foi enviado com sucesso e o atendimento da plataforma entrará em contato para distribuição dos prêmios.',
    pointsNotEnough: 'Pontos insuficientes',
    createTeamSubmitted: 'Equipe criada com sucesso',
    joinedFreeTeam: 'Entrou para a equipe da liberdade',
  },
  section: {
    predictTitle: 'Apostas em partidas',
    predictSub: 'Preveja o resultado do jogo, +{correctPoints} pontos para palpites corretos, +{wrongPoints} ponto para palpites incorretos',
    predictRules: 'Instruções de apostas',
    taskTitle: 'Conclua tarefas para ganhar pontos',
    taskSub: 'Múltiplas tarefas, múltiplas recompensas, acumulação acelerada de lucros',
    exchangeTitle: 'Shopping para resgate de pontos',
    exchangeSub: 'Prêmios valiosos, primeiro a chegar, primeiro a ser servido',
    exchangeRules: 'Instruções de resgate',
    rankTitle: 'Tabela de classificação em tempo real',
    rankSub: 'Competir em força e chegar ao primeiro lugar',
    rulesTitle: 'Regras de atividade',
    rulesSub: 'Transparente, aberto, justo e justo',
  },
  dialog: {
    taskTitle: 'Declaração de missão',
    taskReward: 'Disponível após a conclusão',
    predictConfirmTitle: 'Apostas em partidas',
    predictConfirmHint: 'Qual time você acha que vencerá?',
    predictPay: 'pagar',
    predictPayTip: 'Deduzir da conta de capital, certifique-se de que o saldo é suficiente',
    predictConfirmBtn: 'Confirmar aposta',
    predictSuccessTitle: 'A aposta foi bem sucedida',
    predictSuccessDesc: 'Os resultados das apostas foram enviados com sucesso e os registros podem ser visualizados em "Minhas Apostas".',
    exchangeTitle: 'Troca de produtos',
    exchangeNeedPoints: 'Pontos necessários',
    exchangeBalance: 'Equilíbrio:',
    exchangeContactTitle: 'Preencha pelo menos uma informação de contato',
    exchangeTipTitle: 'Dicas gentis',
    exchangeTip1: 'Preencha pelo menos uma informação de contato. Após o envio, o atendimento da plataforma entrará em contato para comunicar sobre a distribuição dos prêmios.',
    exchangeTip2: 'Se você não for contatado há muito tempo, entre em contato com o atendimento ao cliente para processamento.',
    exchangeConfirm: 'Confirmar troca',
    teamJoinTitle: 'Junte-se à equipe',
    teamCreateDesc: 'Tem certeza de formar uma equipe?',
    teamJoinFreeDesc: 'Tem certeza de que deseja se juntar à Equipe Freedom?',
    teamJoinTipTitle: 'Dicas gentis',
    teamJoinTipDesc: 'Você é membro da equipe de agentes e não pode ingressar em uma equipe gratuita. Você pode convidar seus convidados (agentes) para formar uma equipe para participar de batalhas em equipe.',
    applyAgentContactTitle: 'Aviso importante',
    applyAgentContactPrefix: 'Adicione no Telegram: ',
    applyAgentContactSuffix: ' para solicitar ser agente. Depois de se tornar agente, você poderá criar uma equipe.',
    applyAgentContactBtn: 'Entendi',
  },
  rank: {
    teamRank: 'Classificação da equipe',
    personRank: 'Classificação pessoal',
    yourTeamRank: 'Classificação da sua equipe',
    yourPersonRank: 'sua classificação pessoal',
    captain: 'líder da equipe:',
    currentPoints: 'Pontos atuais',
    members: 'membro',
    teamDetail: 'Detalhes da equipe',
    noRankYet: 'Nenhuma classificação ainda',
  },
  mine: {
    myPoints: 'meus pontos',
    totalPoints: 'total de pontos',
    myPredict: 'Minha aposta',
    myExchange: 'Minha troca',
    myBonus: 'Meu bônus',
    totalBonus: 'Bônus total que recebi',
    bonusPhase: 'Fase de divisão：',
    bonusPhaseFirst: 'Fase 1',
    bonusPhaseSecond: 'Fase 2',
    bonusPhaseThird: 'Fase 3',
    bonusPhaseFinal: 'Fase final',
    bonusTypeTeam: 'Pool da equipe',
    bonusTypePersonal: 'Pool individual',
    bonusPoints: 'Pontos na divisão：',
    bonusType: 'Tipo：',
    bonusAmount: 'Bônus：',
    totalCount: 'Total de {total}',
    myTeam: 'meu time',
    selectTeam: 'Selecione uma equipe',
    predictMatch: 'Partida',
    winTeam: 'equipe vencedora',
    predictResult: 'Resultados de apostas',
    hit: 'Adivinhou corretamente',
    miss: 'Não adivinhei',
    draw: 'Empate',
    exchangeItem: 'Trocar itens',
    contactInfo: 'Informações de contato',
    exchangeStatus: 'Status de resgate',
    currentRank: 'Classificação atual',
    notJoinedTeam: 'Ainda não entrou em um time',
    memberContribution: 'Contribuições dos membros',
    teamTaskContribution: 'Contribuição de tarefa da equipe',
    loading: 'carregando...',
    statusDone: 'Concluído',
    statusPending: 'Processamento',
    statusFail: 'Falha no resgate',
    logCompleteKyc: 'KYC completo',
    logExchangePrize: 'Resgate de prêmios',
    logMatchPredict: 'Apostas em partidas',
    logDailySign: 'Check-in diário',
    logFinishTask: 'Conclua a tarefa',
    taskFirstRecharge: 'Conclua o primeiro depósito >= {amount} USDT',
    pagerTotal: 'Total de {total} itens',
    prevPage: 'Página anterior',
    nextPage: 'Próxima página',
    goTo: 'Vá para',
    page: 'Página',
  },
  mobile: {
    title: 'Apostas na Copa do Mundo',
  },
  nav: {
    entry: 'Apostas na Copa do Mundo',
  },
  mock: {
    korea: 'Coréia do Sul',
    germany: 'Alemanha',
    china: 'China',
    uk: 'REINO UNIDO.',
    france: 'França',
    portugal: 'Portugal',
    senegal: 'Senegal',
    brazil: 'Brasil',
    india: 'Índia',
    turkiye: 'Turquia',
    usa: 'EUA',
    jerseyPack: 'Conjunto de camisa oficial',
    vipCard: 'Cartão de membro criptografado VIP',
    jerseyKeyword: 'camisa',
  },
  predict: {
    round: {
      group: 'fase de grupos',
      r32: 'rodada 32',
      r16: 'rodada 16',
      quarter: 'quartas de final',
      semi: 'semifinais',
      third: 'partida do terceiro lugar',
      final: 'finais',
    },
    status: {
      joined: 'Já participou',
      open: 'Abrir',
      ongoing: 'Durante o jogo',
      ended: 'terminou',
    },
    btn: {
      joined: 'Já apostei',
      open: '{betPaymentAmount}USDT Aposte agora',
      ongoing: 'O jogo está em andamento',
      ended: 'As apostas terminaram',
    },
    joinedMatchPhase: {
      pending: 'Não iniciado',
      ongoing: 'Em andamento',
      ended: 'Encerrado',
    },
    joinedResult: {
      hit: 'Acertou +{points}',
      missPrefix: 'Errou',
      missSuffix: '+{points}',
    },
  },
  rules: {
    fundSource: 'Fonte de fundos',
    poolSplit: 'Compartilhamento do prêmio',
    teamIntro: 'Descrição da equipe',
    poolRulesTitle: 'Descrição do conjunto de prêmios',
    teamRulesTitle: 'Descrição da equipe',
    predictRulesTitle: 'Instruções de apostas',
    exchangeRulesTitle: 'Instruções de resgate',
  },
  rulesText: {
    poolDesc1: 'O bônus inicial do evento é {10万} USDT. Durante o período de validade do evento, parte do bônus empresarial será investida na premiação proporcionalmente ao aumento contínuo da premiação total.',
    poolLine1: '{5%} de cada valor de recarga entra automaticamente no prêmio;',
    poolLine2: '{contractFeePercentageToPool}% de cada taxa de transação de futuros perpétuos entra automaticamente no prêmio;',
    poolLine3: 'Cada vez que um usuário válido é convidado, o prêmio aumentará automaticamente em {10} USDT.',
    poolLine4: '*Valores inferiores a 0,01 USDT não serão contabilizados no prêmio.',
    teamPoolTitle: 'Prêmio de compartilhamento de equipe', 
    teamPoolRuleTitle: 'Regras do prêmio para compartilhamento de equipe',
    userPoolTitle: 'Regras para usuários individuais compartilharem o prêmio',
    poolSplit1: 'Após a determinação das 8 melhores equipes, a equipe classificada em primeiro lugar em pontos dividirá 20% do prêmio total e o saldo continuará acumulando.',
    poolSplit2: 'Depois que as 4 melhores equipes forem determinadas, a equipe classificada em primeiro lugar em pontos dividirá 30% do prêmio total e o saldo continuará acumulando.',
    poolSplit3: 'Após as semifinais, a equipe classificada em primeiro lugar em pontos dividirá 50% da premiação e o saldo continuará acumulando.',
    poolSplit4: 'Após as finais, a equipe classificada em primeiro lugar em pontos dividirá {percentage}% de todo o prêmio. Após a divisão, os pontos disponíveis dos membros da equipe serão zerados.',
    userPoolLine1: 'Ao final do jogo, o usuário que acertou o campeonato terá direito a dividir o prêmio individualmente.',
    userPoolLine2: 'Todos os usuários que acertarem o campeão compartilharão {percentage}% do prêmio com base no total de pontos pessoais. Após a divisão, os pontos disponíveis pessoais serão zerados.',
    poolFormula: '*Exemplo: suponha que uma equipe tenha N usuários elegíveis, com pontos N1, N2, N3...Nn, o valor total do pool no momento da divisão seja A, a proporção desta divisão seja 20% e a proporção da recompensa do capitão seja 20%, então a recompensa do membro da equipe = [(A*20%)(1-0.2)/(N1+N2+N3+...+Nn)]*pontos totais pessoais',
    teamRule1: '1. Somente agentes de primeiro nível podem iniciar a formação de equipes. Se você não é um agente, pode se inscrever para se tornar um agente e formar uma equipe.',
    teamRule2: '2. Se você não é agente nem consegue obter qualificação de agente, pode ingressar na equipe gratuita definida pela plataforma (usuários que não são agentes)',
    teamRule3: '3. Após um agente formar uma equipe, ele e os membros de sua equipe se tornarão automaticamente uma equipe.',
    teamRule4: '4.Total de pontos da equipe = total de pontos dos membros da equipe + pontos de recompensa da tarefa da equipe',
    teamRule5: '5. Requisitos de qualificação para os membros da equipe compartilharem o prêmio: participar de adivinhações ≥ {quizTimesThreshold} vezes durante o evento + volume de negociação em futuros perpétuos ≥ {poolContractThreshold}U',
    predictRule1: '1. As apostas serão encerradas após o início da competição',
    predictRule2: '2. Cada usuário só poderá participar do palpite uma vez por jogo.',
    predictRule3: '3. Você precisa pagar 1 USDT para apostar',
    predictRule4: '4. Adivinhe a equipe vencedora corretamente +10 pontos, adivinhe errado +1 ponto',
    predictRule5: '5. Se a partida (fase de grupos) for um "empate", os pontos serão calculados com base no palpite errado, +1 ponto',
    exchangeRule1: '1. O número de prêmios é limitado e serão resgatados enquanto durarem os estoques; primeiro a chegar, primeiro a ser servido.',
    exchangeRule2: '2. Após o resgate do prêmio, os pontos correspondentes serão deduzidos e os pontos da sua equipe serão deduzidos de acordo.',
    exchangeRule3: '3. Preencha suas informações de contato ao resgatar prêmios, e a equipe da plataforma entrará em contato com você sobre questões subsequentes de distribuição de prêmios',
    exchangeRule4: '4. Os dados de contato preenchidos no momento do resgate estão incorretos, podendo causar o bloqueio do resgate dos prêmios. Por favor, confirme e verifique com atenção e continue atento às novidades.',
    exchangeRule5: '5. Se você não receber contato da plataforma por um longo período, entre em contato com o atendimento ao cliente da plataforma para processamento.',
    timeTitle: 'Tempo de atividade',
    activePeriodLabel: 'Tempo válido da atividade:',
    activePeriodValue: '18 de maio 00:00 ~ 19 de julho 23:59:23',
    activeTip: 'Os pontos são calculados e contabilizados somente após o início do evento e o prêmio começa a ser acumulado.',
    predictPeriodLabel: 'Tempo de aposta:',
    predictPeriodValue: 'Apostas no Campeão: 16 de julho às 04:30:00 ~ 20 de julho às 03:00:00',
    businessTitle: 'regras de negócios',
    businessRule1: '1. Usuários com convite válido: Convite válido significa que a recarga do convidado é ≥{inviteRechargeThreshold}U e o volume de negociação em futuros perpétuos é ≥{contractVolumeThreshold}U.',
    businessRule2: '2. Requisitos de qualificação para membros da equipe compartilharem o prêmio: Participar de adivinhações ≥ {quizTimesThreshold} vezes durante o evento + volume de negociação em futuros perpétuos ≥ {poolContractThreshold}U',
    businessRule3: '3. Os pontos pessoais podem ser trocados por presentes a qualquer momento. Após o resgate, serão deduzidos os pontos pessoais e de equipe correspondentes.',
    businessRule4: '4. O número de prêmios físicos é limitado e deve ser resgatado enquanto durarem os estoques.',
    businessRule5: '5. O prazo para resgate de ingressos para a Copa do Mundo é um dia antes da abertura da Copa do Mundo. Se os bilhetes físicos não puderem ser resgatados por motivos de força maior, eles poderão ser resgatados por USDT equivalentes.',
    statementTitle: 'declaração solene',
    statement1: '1. Cada usuário só poderá utilizar uma conta para participar das atividades. É estritamente proibido usar múltiplas contas (incluindo, entre outras, contas de registro em lote, contas associadas, etc.) para participar de atividades. O sistema monitorará os dispositivos de login e endereços IP das contas participantes. Se for descoberto que várias contas operam usando o mesmo dispositivo ou o mesmo endereço IP, a plataforma tem o direito de determiná-las como uma conta relacionada;',
    statement2: '2. O comportamento comercial dos usuários participantes da atividade deve ser verdadeiro e válido, sendo estritamente proibida qualquer forma de contra-negociação, contra-negociação ou auto-negociação.',
    statement3: '3. A plataforma identificará comportamentos comerciais anormais através do sistema de controle de risco, incluindo, mas não se limitando a: abertura reversa e fechamento de posições de alta frequência, transações de hedge ao mesmo preço e comportamento de lavagem de arbitragem de baixo risco.',
    statement4: '4. Uma vez descoberto um comportamento comercial anormal, a plataforma tem o direito de: compensar os pontos gerados por esta parte da transação, cancelar a qualificação do usuário para participar de atividades, congelar ou retirar recompensas relevantes',
    statement5: '5. O valor do prêmio e distribuição de recompensas estará sujeito aos resultados estatísticos finais da plataforma. A plataforma reserva-se o direito de interpretação final das regras deste evento.',
  },
  exchange: {
    needPoints: 'Pontos necessários',
    stock: 'estoque restante',
    buyNow: 'Resgatar agora',
    soldOut: 'Vendido',
    badgeUnique: 'O único grande prêmio no site',
    badgeOnly3: 'Apenas 3 porções',
    badgeOnly8: '🔥 Apenas 8 peças',
    itemFinalTicket: 'Ingressos para a final da Copa do Mundo',
    itemSignedFootball: 'futebol autografado',
  },
  task: {
    earnPoints: 'Ganhe pontos',
    goFinish: 'completar',
    goTeamTask: 'Faça tarefas para ganhar pontos da equipe',
  },
  taskGroup: {
    daily: 'tarefas diárias',
    invite: 'Convidar tarefas',
    recharge: 'Recarregar tarefas',
    teamTrade: 'Tarefas de negociação em equipe',
    dailyLimitPrefix: 'Limite diário de recompensa',
    teamLimitPrefix: 'Limite diário de recompensas da equipe',
    dailyLimitNum: '50 pontos',
    inviteLimitNum: '100 pontos',
    teamLimitNum: '300 pontos',
    limitSuffix: ', atualizado diariamente às 00:00:00 (GMT+08:00)',
    rechargeLimitSuffix: 'Será calculada apenas a primeira recarga durante o período do evento para verificar se atende ao padrão.',
    inviteCta: 'Convide agora e ganhe pontos',
    taskPredictOnce: 'Cada vez que você participa de um evento apostando',
    taskTrade10000: 'Cada volume cumulativo de negociação em futuros perpétuos concluída é de {tradeVolume}U',
    taskInviteValidUser: 'Cada vez que um convite de usuário válido é concluído',
    taskInviteRegister: 'Convide amigos para se registrar',
    taskInviteKyc: 'Convide amigos para completar o KYC',
    taskInviteRecharge: 'Convide amigos para completar a primeira recarga',
    taskFirstRecharge: 'Primeiro depósito >= {amount} USDT', 
    taskTeamTrade10000: 'Para cada volume cumulativo de {tradeVolume} USDT em negociações de futuros perpétuos concluídas, a equipe receberá +{teamBonusPoints} pontos.',
  },
};
export {
  apis,
  games,
  mail,
  h5,
  trading,
  download,
  login,
  user,
  advertise,
  otcMerchant,
  otc,
  menu,
  time,
  state,
  text,
  seckillRes,
  header,
  hyy,
  index,
  indexPage,
  Verification,
  NAVS,
  FOOTERS,
  SIDEBAR,
  seckill,
  apply,
  recommend,
  market,
  banner,
  card,
  news,
  info,
  navCard,
  choice,
  plat,
  risk,
  license,
  footer,
  merchandiser,
  codeInfo,
  placeOrder,
  tableList,
  codelist,
  contractHyy,
  common,
  dialog,
  panKou,
  invite,
  property,
  contest,
  taskCenter,
  ieo,
  earn,
  tradingContest,
  agent,
  live,
  hongbao,
  worldCup
};



// WEBPACK FOOTER //
// ./src/i18n/lang/public/pt_BR.js